import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import Select from "react-select";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import PrescriptionHistoryModal from "./PrescriptionHistoryModal";
import PrescriptionDetailModal from "./PrescriptionDetailModal";
import MedicineDrop from "./MedicineDrop";
import icon1 from "../../../../../../src/assets/images/icons8-history-96.png";
import {
  createPrescriptionAction,
  getSuggestedPrescriptionAction,
  getPatientPrescriptionsAction,
  updatePrescriptionAction
} from "../../../../../store/actions/PrescriptionAction";
import { getMedicinesAction } from "../../../../../store/actions/MedicinesAction";
import { showErrorAlert, handleSuccess } from "../../../../../services/ErrorHandlingService";
import { FaMicrophone } from "react-icons/fa";
import { getDefaultDoseAction } from "../../../../../store/actions/DefaultDoseAction";
import { getFrequencyAction } from "../../../../../store/actions/FrequencyAction";
import { getAnupanList } from "../../../../../services/AnupanService";
import { getAnupanAction } from "../../../../../store/actions/AnupanAction";
import { getMedicineTypeAction } from "../../../../../store/actions/MedicineTypeActions";
import { getHowToTakeAction } from "../../../../../store/actions/HowToTakeAction";
import { getPathyaAction } from "../../../../../store/actions/PathyaActions";
// import state from "sweetalert/typings/modules/state"
// import { useRef, useState } from "react"

// Extract first number from text
const extractNumber = (text) => {
  if (!text) return 1;
  const match = text.match(/\d+/);
  return match ? Number(match[0]) : 1;
};

// Convert duration (0.25 month system) to total days
const getTotalDays = (durationValue) => {
  if (!durationValue) return 0;

  const value = Number(durationValue);
  const months = Math.floor(value);
  const fraction = value - months;

  let extraDays = 0;

  if (fraction === 0.25) extraDays = 7;
  else if (fraction === 0.5) extraDays = 15;
  else if (fraction === 0.75) extraDays = 22;

  return months * 30 + extraDays;
};

const PatientPrescription = () => {
  const dispatch = useDispatch()
  const patientDetails = useSelector((state) => state.patients?.patientDetails)
  const prescriptions = useSelector((state) => state.prescriptions.patientPrescriptions || [])
  const suggestedPrescriptions = useSelector(
    (state) => state.prescriptions.suggestedPrescriptions || []
  )

  const medicines = useSelector(
    (state) => state.medicines.medicines?.medicines || []
  )

  const externalMedicines = medicines.filter(
    (m) => m.medicine_int_ext_type === "External"
  )

  const internalMedicines = medicines.filter(
    (m) => m.medicine_int_ext_type !== "External"
  )

  const doses = useSelector(state => state.defaultDose?.doses ?? []);
  const frequencies = useSelector(state => state.frequency?.list ?? []);
  const medicineTypes = useSelector(state => state.medicineType?.list ?? []);
  const anupans = useSelector(state => state.anupan?.list ?? []);
  // const howToTake = useSelector(state => state.howToTake?.list ?? []);
  const pathyaList = useSelector(
    (state) => state.pathya?.list ?? []
  );
  const howToTake = useSelector(
    (state) => state.howToTake?.list ?? []
  );
  console.log("DOSES:", doses)
  console.log("FREQUENCIES:", frequencies)
  console.log("TYPES:", medicineTypes)
  console.log("ANUPANS:", anupans)

  const doseOptions = (doses || [])
    .filter(d => d.dose_status === "Active")
    .map(d => ({
      value: String(d.id),
      label: d.dose_text,
      numeric: extractNumber(d.dose_text)  // 🔥 important
    }));

  const frequencyOptions = frequencies
    .filter(f => f.frequency_status === "Active")
    .map(f => ({
      value: f.frequency_id,
      label: f.frequency_text,
      numeric: extractNumber(f.frequency_text) // 🔥 important
    }));

  const medicineTypeOptions = medicineTypes
    .filter(t => t.medicine_type_status === "Active")
    .map(t => ({
      value: t.medicine_type_id,
      label: t.medicine_type_text
    }));

  const howToTakeOptions = (howToTake || [])
    .filter(h => h.status === "Active")
    .map(h => ({
      value: String(h.id),
      label: h.text
    }));

  const howToTakeOptionsWithOther = [
    ...howToTakeOptions,
    { value: "other", label: "Other" }
  ];

  const anupanOptions = anupans
    .filter(a => a.anupana_status === "Active")
    .map(a => ({
      value: a.id,
      label: a.anupana_text
    }));

  const pathyaOptions = (pathyaList || [])
    .filter(p => p.pathya_status === "Active")
    .map(p => ({
      value: p.pathya_id,
      label: p.pathya_name
    }));
  console.log("RAW howToTake:", howToTake);
  console.log("Mapped options:", howToTakeOptions);

  // Get userDetails ONCE outside hooks
  const storedUser = localStorage.getItem("userDetails")
  const parsedUser = storedUser ? JSON.parse(storedUser) : null

  // State
  const [currentUser, setCurrentUser] = useState(parsedUser)
  const [treatmentType, setTreatmentType] = useState("")
  const [showVirechan, setShowVirechan] = useState(false)
  const [karmaMode, setKarmaMode] = useState("offline")
  const [showViman, setShowViman] = useState(false)
  const [showBasti, setShowBasti] = useState(false)
  const [virechanChecked, setVirechanChecked] = useState(false)
  const [vimanChecked, setVimanChecked] = useState(false)
  const [bastiChecked, setBastiChecked] = useState(false)
  const [virechanSubs, setVirechanSubs] = useState({ ghrutpan: false })
  const [vimanSubs, setVimanSubs] = useState({ lagu: false })
  const [bastiSubs, setBastiSubs] = useState({ kadhyachi: false, dudhachi: false })
  const [discountPercentage, setDiscountPercentage] = useState("");
  const [discountAmount, setDiscountAmount] = useState("");

  const [mainOptions, setMainOptions] = useState([])

  const [isAutoCalculated, setIsAutoCalculated] = useState(false);

  // customized medicine
  const [showCustomMedicineTable, setShowCustomMedicineTable] = useState(false)
  const [customizedPrescriptions, setCustomizedPrescriptions] = useState([])
  const [isEditingCustom, setIsEditingCustom] = useState(false)
  const [editCustomIndex, setEditCustomIndex] = useState(null)
  const [sortField, setSortField] = useState("")
  const [sortOrder, setSortOrder] = useState("asc")
  const [diseases, setDiseases] = useState([])
  const [errors, setErrors] = useState({})
  const [modifiedPrescriptions, setModifiedPrescriptions] = useState([])
  const [isEditing, setIsEditing] = useState(false)
  const [editIndex, setEditIndex] = useState(null)
  const [duration, setDuration] = useState(null)
  const [validity, setValidity] = useState(null)
  const [note, setNote] = useState("")
  const [pathyas, setPathyas] = useState(null)
  const [showRow, setShowRow] = useState(false)
  const [historyModalVisible, setHistoryModalVisible] = useState(false)
  const [detailModalVisible, setDetailModalVisible] = useState(false)
  const [selectedPrescription, setSelectedPrescription] = useState(null)
  const [prescriptionData, setPrescriptionData] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [panchakarmaRecommended, setPanchakarmaRecommended] = useState(false)
  const [selectedPrescriptions, setSelectedPrescriptions] = useState([])
  const [editingPrescriptionId, setEditingPrescriptionId] = useState(null);

  const [discountType, setDiscountType] = useState("");
  // "percentage" | "amount"
  const recognitionRef = useRef(null)
  // const [isRecording, setIsRecording] = useState(false)
  const [activeMic, setActiveMic] = useState(null)
  // "notes" | "pathyas" | null
  const [speechLang, setSpeechLang] = useState("en-IN")

  // 🔥 NEW: store unit text for dose display
  const [selectedMedicineUnit, setSelectedMedicineUnit] = useState("");

  const toggleSpeechLang = () => {
    setSpeechLang((prev) => (prev === "en-IN" ? "mr-IN" : "en-IN"))
  }

  const startListening = (field, setter) => {
    if (currentUser?.role_name !== "Doctor") return

    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition

    if (!SpeechRecognition) {
      alert("Speech recognition not supported")
      return
    }

    if (activeMic) return

    const recognition = new SpeechRecognition()
    recognitionRef.current = recognition

    recognition.lang = speechLang
    recognition.continuous = false
    recognition.interimResults = false

    setActiveMic(field)

    recognition.onresult = (event) => {
      const spokenText = event.results[0][0].transcript

      setter(spokenText) // ✅ FIXED
    }

    recognition.onend = () => {
      recognitionRef.current = null
      setActiveMic(null)
    }

    recognition.onerror = () => {
      recognitionRef.current = null
      setActiveMic(null)
    }

    recognition.start()
  }

  useEffect(() => {
    dispatch(getMedicineTypeAction())
    dispatch(getDefaultDoseAction())
    dispatch(getFrequencyAction())
    dispatch(getAnupanAction())
    dispatch(getHowToTakeAction())
    dispatch(getPathyaAction())  // create this
  }, [dispatch])

  // const STATIC_MEDICINES = [
  //   { value: "101", label: "Triphala Churna" },
  //   { value: "102", label: "Ashwagandha Vati" },
  //   { value: "103", label: "Dashmoolarishta" },
  //   { value: "104", label: "Punarnava Mandur" },
  //   { value: "105", label: "Sitopaladi Churna" },
  // ];

  // Hook-safe mainOptions initialization
  useEffect(() => {
    setMainOptions([
      {
        key: "virechan",
        label: "Virechan",
        checked: virechanChecked,
        setChecked: setVirechanChecked,
        subs: virechanSubs,
        setSubs: setVirechanSubs,
      },
      {
        key: "vaman",
        label: "Vaman",
        checked: vimanChecked,
        setChecked: setVimanChecked,
        subs: vimanSubs,
        setSubs: setVimanSubs,
      },
      {
        key: "basti",
        label: "Basti",
        checked: bastiChecked,
        setChecked: setBastiChecked,
        subs: bastiSubs,
        setSubs: setBastiSubs,
      },
    ])
  }, [virechanChecked, vimanChecked, bastiChecked, virechanSubs, vimanSubs, bastiSubs])

  if (!currentUser) return null // early return is safe now
  const isDoctor = currentUser.role_name === "Doctor"
  // ...rest of your component


  // Converts decimal month to label
  const getDurationLabel = (value) => {
    const month = Math.floor(value);
    const fraction = value - month;

    // Convert fractional month to days
    const days = fraction === 0.25 ? 7 : fraction === 0.5 ? 15 : fraction === 0.75 ? 22 : 0;

    if (month === 0) return `${days} Days`;
    if (days === 0) return `${month} Month${month > 1 ? "s" : ""}`;

    return `${month} Month${month > 1 ? "s" : ""} ${days} Days`;
  };

  // Generate values like 0.25, 0.5, 0.75, 1, 1.25, ..., up to 12
  const durationOptions = Array.from({ length: 12 * 4 }, (_, i) => {
    const value = (i + 1) * 0.25;

    // Limit up to 12 months if needed
    if (value > 12) return null;

    return {
      value: value.toString(),
      label: getDurationLabel(value),
    };
  }).filter(Boolean);


  const validityOptions = Array.from({ length: 360 }, (_, i) => ({
    value: String(i + 1),
    label: `${i + 1} Day${i + 1 > 1 ? "s" : ""}`,
  }));
  // calculate Medicine array price
  const calculateMedicinePrice = (medicine, quantity) => {
    // 🔥 Safe parsing
    const safeQty = Number(quantity);
    const qty = isNaN(safeQty) || safeQty <= 0 ? 0 : safeQty;

    const basePrice = Number.parseFloat(medicine?.base_price || 0) || 0;
    const CGST = Number.parseFloat(medicine?.CGST || 0) || 0;
    const SGST = Number.parseFloat(medicine?.SGST || 0) || 0;
    const IGST = Number.parseFloat(medicine?.IGST || 0) || 0;

    // 🔥 Core calculation
    let item_subtotal = qty * basePrice;
    let item_cgst_amount = item_subtotal * (CGST / 100);
    let item_sgst_amount = item_subtotal * (SGST / 100);
    let item_igst_amount = item_subtotal * (IGST / 100);
    let item_gst_price = item_subtotal + item_cgst_amount + item_sgst_amount;
    let item_igst_price = item_subtotal + item_igst_amount;

    // 🔥 FINAL SAFETY (NO Infinity / NaN)
    const safe = (val) => {
      if (!isFinite(val) || isNaN(val)) return "0.00";
      return val.toFixed(2);
    };

    return {
      item_subtotal: safe(item_subtotal),
      item_cgst_amount: safe(item_cgst_amount),
      item_sgst_amount: safe(item_sgst_amount),
      item_igst_amount: safe(item_igst_amount),
      item_gst_price: safe(item_gst_price),
      item_igst_price: safe(item_igst_price),
    };
  }; ``
  const tableRef = useRef(null);

  const scrollToTable = () => {
    requestAnimationFrame(() => {
      if (tableRef.current) {
        tableRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  };

  // calculate total medicines amount
  const calculateTotalFromMedicines = (medicines) => {
    const toNumber = (value) => {
      if (typeof value === "number") return value
      if (typeof value === "string") return Number.parseFloat(value.trim()) || 0
      return 0
    }

    return medicines.reduce(
      (totals, item) => {
        totals.items_subtotal += toNumber(item.item_subtotal)
        totals.items_cgst_amount += toNumber(item.item_cgst_amount)
        totals.items_sgst_amount += toNumber(item.item_sgst_amount)
        totals.items_igst_amount += toNumber(item.item_igst_amount)
        totals.gst_price += toNumber(item.gst_price)
        totals.igst_price += toNumber(item.igst_price)
        return totals
      },
      {
        items_subtotal: 0,
        items_cgst_amount: 0,
        items_sgst_amount: 0,
        items_igst_amount: 0,
        gst_price: 0,
        igst_price: 0,
      },
    )
  }

  const fetchSuggestedPrescriptions = async (disease_ids) => {
    try {
      const patientId = patientDetails?.patient_id
      if (!patientId || !disease_ids || disease_ids.length === 0) {
        return
      }
      console.log("Fetching suggested prescriptions for disease_ids:", disease_ids)
      const response = await dispatch(
        getSuggestedPrescriptionAction({
          patient_id: patientId,
          disease_ids,
        }),
      )
      console.log("Suggested prescriptions response:", response)
    } catch (error) {
      console.error("Failed to fetch suggested prescriptions", error)
    }
  }

  // Fix: Update modifiedPrescriptions when suggestedPrescriptions change
  // useEffect(() => {
  //   if (suggestedPrescriptions && suggestedPrescriptions.length > 0) {
  //     console.log("Processing suggested prescriptions:", suggestedPrescriptions)
  //     const newPrescriptions = suggestedPrescriptions.map((item) => {
  //       const quantity = 1
  //       const prices = calculateMedicinePrice(item, quantity)
  //       return {
  //         medicine_id: item.medicine_id,
  //         medicineName: item.medicine_name,
  //         dose: item.default_dose || "1",
  //         frequency: item.default_frequency || "1",
  //         quantity: "1",
  //         howToTake: item.default_instructions || "After meal",
  //         base_price: item.base_price,
  //         CGST: item.CGST,
  //         SGST: item.SGST,
  //         IGST: item.IGST,
  //         cgst_sgst_price: item.cgst_sgst_price,
  //         igst_price: item.igst_price,
  //         item_subtotal: prices.item_subtotal,
  //         item_cgst_amount: prices.item_cgst_amount,
  //         item_sgst_amount: prices.item_sgst_amount,
  //         item_igst_amount: prices.item_igst_amount,
  //         item_gst_price: prices.item_gst_price,
  //         item_igst_price: prices.item_igst_price,
  //       }
  //     })
  //     setModifiedPrescriptions(newPrescriptions)
  //     setSelectedPrescriptions([])
  //     console.log("Set modifiedPrescriptions:", newPrescriptions)
  //   }
  // }, [suggestedPrescriptions])
  useEffect(() => {
    // Skip everything if the logged-in user is not a Doctor
    if (!isDoctor) {
      console.log("Skipping suggested prescriptions update — user is not a Doctor.")
      return
    }

    if (suggestedPrescriptions && suggestedPrescriptions.length > 0) {
      const newPrescriptions = suggestedPrescriptions.map((item) => {
        const doseNum =
          Number(item.dose) ||
          extractNumber(item.dose_text) ||
          1;

        const freqNum =
          Number(item.frequency) ||
          extractNumber(item.frequency_text) ||
          1;

        // ✅ duration logic
        let totalDays = 1;

        if (formData.treatmentType === "customMedicine") {
          totalDays = Number(formData.prescriptionDuration) || 1;
        } else {
          totalDays = getTotalDays(Number(duration?.value)) || 1;
        }

        // ✅ required tablets
        const requiredTabs = doseNum * freqNum * totalDays;

        // ✅ package qty
        const packQty = Number(item.package_qty || 1);

        // ✅ final packs
        const packagesNeeded = Math.ceil(requiredTabs / packQty);

        const prices = calculateMedicinePrice(item, packagesNeeded);

        return {
          medicine_id: item.medicine_id,
          medicineName: item.medicine_name,

          medicine_type: item.medicine_type_text || "Not specified",

          dose: item.dose_text || String(doseNum),
          frequency: item.frequency_text || "",

          // 🔥 FINAL QUANTITY
          quantity: packagesNeeded,

          howToTake: item.default_instructions || "After meal",
          anupan: item.anupana_text || "-",

          default_dose_id: item.default_dose_id || item.dose,
          default_frequency_id: item.default_frequency_id || item.frequency,
          how_to_take_id: item.how_to_take_id || "",
          anupana_id: item.anupana_id || "",

          package_qty: packQty, // 🔥 IMPORTANT future use sathi

          base_price: item.base_price,
          CGST: item.CGST,
          SGST: item.SGST,
          IGST: item.IGST,

          cgst_sgst_price: item.cgst_sgst_price,
          igst_price: item.igst_price,

          item_subtotal: prices.item_subtotal,
          item_cgst_amount: prices.item_cgst_amount,
          item_sgst_amount: prices.item_sgst_amount,
          item_igst_amount: prices.item_igst_amount,
          item_gst_price: prices.item_gst_price,
          item_igst_price: prices.item_igst_price,
        };
      });

      // ✅ Merge with existing instead of overwrite
      setModifiedPrescriptions((prev) => {
        const all = [...prev, ...newPrescriptions]
        return all.filter(
          (item, index, self) =>
            index === self.findIndex((p) => String(p.medicine_id) === String(item.medicine_id))
        )
      })
    }
  }, [suggestedPrescriptions, isDoctor])


  // Load medicines for form details lookup (MedicineDrop handles lazy loading for selection)
  useEffect(() => {
    dispatch(getMedicinesAction(false))
  }, [dispatch])


  useEffect(() => {
    if (!duration || modifiedPrescriptions.length === 0) return;

    const totalDays = getTotalDays(Number(duration?.value)) || 1;

    const updated = modifiedPrescriptions.map((item) => {
      const doseNum =
        extractNumber(item.dose) || Number(item.default_dose_id) || 1;

      const freqNum =
        extractNumber(item.frequency) || Number(item.default_frequency_id) || 1;

      const packQty = Number(item.package_qty || 1);

      const requiredTabs = doseNum * freqNum * totalDays;

      const packagesNeeded = Math.ceil(requiredTabs / packQty);

      const prices = calculateMedicinePrice(item, packagesNeeded);

      return {
        ...item,

        quantity: packagesNeeded, // 🔥 auto update

        item_subtotal: prices.item_subtotal,
        item_cgst_amount: prices.item_cgst_amount,
        item_sgst_amount: prices.item_sgst_amount,
        item_igst_amount: prices.item_igst_amount,
        item_gst_price: prices.item_gst_price,
        item_igst_price: prices.item_igst_price,
      };
    });

    setModifiedPrescriptions(updated);

  }, [duration]); // 🔥 ONLY duration change la trigger

  // FIXED: Include medicine_id in the medicines mapping with extensive debugging
  useEffect(() => {
    console.log("=== PRESCRIPTION DATA FORMATTING ===")
    console.log("Raw prescriptions from Redux:", prescriptions)
    if (prescriptions && prescriptions.length > 0) {
      const formattedData = prescriptions.map((prescription, prescIndex) => {
        console.log(`Processing prescription ${prescIndex}:`, prescription)
        const isoDateStr = prescription.created_at?.replace(" ", "T")
        const dateObj = new Date(isoDateStr)

        // Log the medicines data for debugging
        console.log(`Prescription ${prescIndex} medicines:`, prescription.medicines)

        const formattedPrescription = {
          prescriptionId: prescription.prescription_id,
          patientId: prescription.patient_id,
          duration: prescription.duration,
          validity: prescription.prescription_validity_days,
          note: prescription.note || "No notes",
          pathyas: prescription.pathyas || "",
          prescribed_by: prescription.prescribed_by === "" ? "-" : prescription.prescribed_by,
          date: isNaN(dateObj)
            ? "Invalid Date"
            : dateObj.toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            }),
          diseases:
            prescription.diseases && prescription.diseases.length > 0
              ? prescription.diseases.map((d) => d.disease_name).join(", ")
              : "-",
          status: prescription.status,
          pathyas: prescription.pathyas || "",
          pathya_id: prescription.pathya_id,
          is_stop: prescription.is_stop,
          stopped_date: prescription.stopped_date,
          mark_as_complete: prescription.mark_as_complete,
items_subtotal: prescription.items_subtotal,
prescription_payment_status:
  prescription.prescription_payment_status,
          prescription_validity_days: prescription.prescription_validity_days,
          discount_type: prescription.discount_type,
          discount_amount: prescription.discount_amount,
          discount_percentage: prescription.discount_percentage,
          panchakarma_recommended: prescription.panchakarma_recommended,
          // CRITICAL: Include medicine_id in the medicines mapping
          medicines: (prescription.medicines || prescription.Medicines || []).map((med, medIndex) => {
            console.log("MEDICINES SOURCE:", prescription.medicines);
            console.log("MEDICINES ALT:", prescription.Medicines);
            console.log(`Mapping medicine ${medIndex} in prescription ${prescIndex}:`, med)
            console.log(`Raw medicine_id: ${med.medicine_id} (type: ${typeof med.medicine_id})`)
            const mappedMedicine = {
              medicine_id: med.medicine_id, // CRITICAL: This must be preserved
              prescriptionMedicineId: med.prescription_medicine_id,
              medicine_name: med.medicine_name,
              medicineName: med.medicine_name,
              medicine_type: med.medicine_type || "Not specified",
              // medicine_type:
              //   med.medicine_type ||
              //   med.medicineType ||
              //   "Not specified",
              dose: med.dose,
              frequency: med.frequency,
              qty: med.qty,
              quantity: med.qty,
              delivered_qty: med.delivered_qty,
              updated_qty: med.updated_qty,
              deliveredQuantity: med.delivered_qty,
              delivery_status: med.delivery_status,
              delivery_option: med.delivery_option,
              how_to_take: med.how_to_take,
              howToTake: med.how_to_take,
              // anupan: med.anupan,
              anupan: med.anupan || med.anupana_text || "",
              anupana_text: med.anupana_text || "",
              is_hold: med.is_hold,
              is_custom: med.is_custom,
              custom_duration_in_days: med.custom_duration_in_days,
              default_dose_id: med.default_dose_id,        // 🔥 ADD
              default_frequency_id: med.default_frequency_id, // 🔥 ADD
              package_qty: med.package_qty,
            }
            console.log(`Mapped medicine ${medIndex}:`, mappedMedicine)
            console.log(
              `Mapped medicine_id: ${mappedMedicine.medicine_id} (type: ${typeof mappedMedicine.medicine_id})`,
            )
            return mappedMedicine
          }),
        }
        console.log(`Formatted prescription ${prescIndex}:`, formattedPrescription)
        return formattedPrescription
      })

      console.log("=== FINAL FORMATTED DATA ===")
      console.log("All formatted prescriptions:", formattedData)

      // Verify the first prescription's medicines
      if (formattedData.length > 0 && formattedData[0].medicines.length > 0) {
        console.log("=== VERIFICATION ===")
        console.log("First prescription medicines:", formattedData[0].medicines)
        formattedData[0].medicines.forEach((med, index) => {
          console.log(`Verified medicine ${index}:`, {
            medicine_id: med.medicine_id,
            type: typeof med.medicine_id,
            medicine_name: med.medicine_name,
          })
        })
      }

      setPrescriptionData(formattedData)
    }
  }, [prescriptions])

  // Debug: Log prescriptionData when it changes
  useEffect(() => {
    console.log("=== PRESCRIPTION DATA STATE UPDATED ===")
    console.log("prescriptionData state:", prescriptionData)
    if (prescriptionData.length > 0) {
      prescriptionData.forEach((prescription, index) => {
        console.log(`State prescription ${index}:`, prescription)
        if (prescription.medicines && prescription.medicines.length > 0) {
          prescription.medicines.forEach((med, medIndex) => {
            console.log(`State medicine ${medIndex}:`, {
              medicine_id: med.medicine_id,
              type: typeof med.medicine_id,
              medicine_name: med.medicine_name,
            })
          })
        }
      })
    }
  }, [prescriptionData])

  const [formData, setFormData] = useState({
    diseaseName: [],
    prescriptionDuration: "",
    isRegularServiceCall: true,
    frequencyDays: "",
    medicineName: null,
    medicine_type: "",
    dose: "",
    frequency: "",
    quantity: "",
    howToTake: "",
    anupan: "",
    base_price: "",
    CGST: "",
    SGST: "",
    IGST: "",
    cgst_sgst_price: "",
    igst_price: "",
    item_subtotal: "",
    item_cgst_amount: "",
    item_sgst_amount: "",
    item_igst_amount: "",
    item_gst_price: "",
    item_igst_price: "",
    // validity: "",
  })

  console.log(formData.default_dose_id)
  console.log(doseOptions)
  useEffect(() => {
    if (patientDetails?.diseases?.length) {
      const options = patientDetails.diseases.map((d) => ({
        value: d.disease_id,
        label: d.disease_name,
      }))
      setDiseases(options)
      const disease_ids = patientDetails.diseases.map((d) => d.disease_id)
      const diseaseParam = disease_ids.join("|")
      fetchSuggestedPrescriptions(diseaseParam)
    } else {
      setDiseases([])
      // setModifiedPrescriptions([])
    }
  }, [patientDetails])

  // const handleDiseaseChange = (selectedOptions) => {
  //   console.log("Disease selection changed:", selectedOptions)
  //   setFormData((prev) => ({
  //     ...prev,
  //     diseaseName: selectedOptions || [],
  //   }))
  //   const disease_ids = selectedOptions?.map((option) => option.value) || []
  //   if (disease_ids.length > 0) {
  //     const diseaseParam = disease_ids.join("|")
  //     fetchSuggestedPrescriptions(diseaseParam)
  //   } else {
  //     setModifiedPrescriptions([])
  //   }
  // }
  const handleDiseaseChange = (selectedOptions) => {
    console.log("Disease selection changed:", selectedOptions)
    setFormData((prev) => ({
      ...prev,
      diseaseName: selectedOptions || [],
    }))

    const disease_ids = selectedOptions?.map((option) => option.value) || []
    if (disease_ids.length > 0) {
      const diseaseParam = disease_ids.join("|")
      fetchSuggestedPrescriptions(diseaseParam)
    } else {
      // ❌ Do NOT clear prescriptions here
      // Just skip fetching
      console.log("No diseases selected, keeping prescriptions intact.")
    }
  }

  // const handleChangeon = (selectedOption) => {
  //   setDuration(selectedOption)
  // }

  // For Prescription Duration
  // const handleDurationChange = (selectedOption) => {
  //   setDuration(selectedOption);

  //   setIsAutoCalculated(true); // 🔥 ADD THIS

  //   setFormData(prev => ({
  //     ...prev,
  //     prescriptionDuration: selectedOption?.value || "",
  //   }));
  // };
  const handleDurationChange = (
    selectedOption
  ) => {
  
    setDuration(selectedOption);
  
    setIsAutoCalculated(true);
  
    setFormData((prev) => ({
      ...prev,
      prescriptionDuration:
        selectedOption?.value || "",
    }));
  
    // ✅ CLEAR QUANTITY ERROR
    if (selectedOption) {
  
      setErrors((prev) => ({
        ...prev,
        quantity: "",
      }));
  
    }
  
  };
  // For Prescription Validity
  const handleValidityChange = (selectedOption) => {
    setValidity(selectedOption);
    // setFormData((prev) => ({
    //   ...prev,
    //   validity: selectedOption?.value || "",
    // }));
  };

  const handleONChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleMedicineChange = (selectedOption) => {
    const selectedMedicine = medicines.find((m) => String(m.medicine_id) === selectedOption.value)
    const quantity = 2
    const prices = calculateMedicinePrice(selectedMedicine, quantity)
    setFormData((prev) => ({
      ...prev,
      medicine_id: selectedOption.value,
      medicineName: selectedOption,
      medicine_type: selectedMedicine?.medicine_type || "",
      dose: selectedMedicine?.default_dose || "",
      frequency: selectedMedicine?.default_frequency || "",
      howToTake: selectedMedicine?.how_to_take || "",
      anupana_id: selectedMedicine?.anupana_id || "",
      anupan: selectedMedicine?.anupana_text || "",
      default_instructions: selectedMedicine?.default_instructions || "",
      quantity: quantity.toString(),
      base_price: selectedMedicine?.base_price || "1",
      CGST: selectedMedicine?.CGST || "1",
      SGST: selectedMedicine?.SGST || "1",
      IGST: selectedMedicine?.IGST || "1",
      cgst_sgst_price: selectedMedicine?.cgst_sgst_price || "1",
      igst_price: selectedMedicine?.igst_price || "",
      item_subtotal: prices.item_subtotal,
      item_cgst_amount: prices.item_cgst_amount,
      item_sgst_amount: prices.item_sgst_amount,
      item_igst_amount: prices.item_igst_amount,
      item_gst_price: prices.item_gst_price,
      item_igst_price: prices.item_igst_price,
    }))
    // 🔥 store unit for dose display
    setSelectedMedicineUnit(selectedMedicine?.unit_text || "")
  }

  // customized medicine
  const handleCustomDelete = (indexToDelete) => {
    const updatedList = customizedPrescriptions.filter((_, idx) => idx !== indexToDelete)
    setCustomizedPrescriptions(updatedList)
  }

  // const handleCustomEdit = (index) => {
  //   const item = customizedPrescriptions[index]
  //   setFormData((prev) => ({
  //     ...prev,
  //     medicineName: { value: `custom_${index}`, label: item.name },
  //     medicine_type: item.medicine_type,
  //     dose: item.dose,
  //     frequency: item.frequency,
  //     quantity: item.quantity,
  //     howToTake: item.howToTake,
  //     prescriptionDuration: item.duration || "",
  //     // prescriptionValidity: item.validity || "",
  //     validity: item.validity || "",

  //     default_dose_id: doseOptions.find(d => d.label === item.dose)?.value || "",
  //     default_frequency_id: frequencyOptions.find(f => f.label === item.frequency)?.value || "",
  //     how_to_take_id: howToTakeOptionsWithOther.find(h => h.label === item.howToTake)?.value || "",
  //     // anupana_id: anupans.find(a => a.label === item.anupan)?.value || "",
  //     anupana_id: anupans.find(a => a.label === item.anupan)?.value || null,
  //     anupan: item.anupan || "",
  //   }))
  //   setEditCustomIndex(index)
  //   setIsEditingCustom(true)
  //   // setShowCustomMedicineTable(true) // Enable custom medicine mode
  //   setShowRow(false)
  // }
  const handleCustomEdit = (index) => {
    const item = customizedPrescriptions[index];
  
    // ✅ Fetch the original medicine to get package_qty and other defaults
    const originalMedicine = medicines.find(
      (m) => String(m.medicine_id) === String(item.medicine_id)
    );
  
    setFormData({
      ...initialFormData,
      medicineName: { value: item.medicine_id, label: item.name },
      medicine_type: item.medicine_type || originalMedicine?.medicine_type_text || "",
      dose: item.dose,
      frequency: item.frequency,
      quantity: item.quantity,  // temporary, will be recalculated
      howToTake: item.howToTake,
      prescriptionDuration: item.duration || "",
      validity: item.validity || "",
      default_dose_id: doseOptions.find(d => d.label === item.dose)?.value || "",
      default_frequency_id: frequencyOptions.find(f => f.label === item.frequency)?.value || "",
      how_to_take_id: howToTakeOptionsWithOther.find(h => h.label === item.howToTake)?.value || "",
      anupana_id: anupans.find(a => a.label === item.anupan)?.value || null,
      anupan: item.anupan || "",
      // 🔥 CRUCIAL – take package_qty from original medicine, fallback to stored value, then default 1
      package_qty: originalMedicine?.package_qty || item.package_qty || "1",
      treatmentType: "customMedicine",
      isExternal: item.isExternal || false,
    });
  
    setEditCustomIndex(index);
    setIsEditingCustom(true);
    setShowRow(false);
  };
  const handleCustomSave = () => {
    const newErrors = {}
    if (!formData.medicineName) newErrors.medicineName = "Medicine is required."
    if (!formData.medicine_type.trim()) newErrors.medicine_type = "Type is required."
    if (!formData.dose.trim()) newErrors.dose = "Dose is required."
    if (!formData.frequency.trim()) newErrors.frequency = "Frequency is required."
    // 🔥 FIX: show duration error instead of quantity
    if (!duration && !formData.prescriptionDuration?.trim()) {
      newErrors.quantity = "Please select prescription duration first"
    } else if (!formData.quantity || Number(formData.quantity) <= 0) {
      newErrors.quantity = "Quantity is required."
    }
    if (!formData.how_to_take_id)
      newErrors.howToTake = "How to take is required."
    if (!formData.prescriptionDuration.trim()) newErrors.prescriptionDuration = "Duration is required."

    setErrors(newErrors)
    if (Object.keys(newErrors).length > 0) return

    // Find the medicine in the master list to get its pricing info
    const selectedMedicine = medicines.find((m) => String(m.medicine_id) === formData.medicineName.value)
    const pricing = calculateMedicinePrice(
      selectedMedicine || { base_price: 0, CGST: 0, SGST: 0, IGST: 0 },
      formData.quantity,
    )

    const howToTakeObj = howToTakeOptions.find(
      h => String(h.value) === String(formData.how_to_take_id)
    );
    const updated = [...customizedPrescriptions];

    updated[editCustomIndex] = {
      ...updated[editCustomIndex],
      ...formData,
    };

    setCustomizedPrescriptions(updated);

    // reset
    setIsEditingCustom(false);
    setEditCustomIndex(null);

    const newCustomized = {
      medicine_id: formData.medicineName.value,
      name: formData.medicineName.label,
      medicine_type: formData.medicine_type,
      dose: formData.dose,
      frequency: formData.frequency,
      quantity: formData.quantity,
      howToTake: howToTakeObj?.label || formData.howToTake || "",
      anupan: formData.anupan,
      duration: formData.prescriptionDuration,
      validity: formData.validity,
      base_price: selectedMedicine?.base_price || "0.00",
      CGST: selectedMedicine?.CGST || "0",
      SGST: selectedMedicine?.SGST || "0",
      IGST: selectedMedicine?.IGST || "0",
      cgst_sgst_price: selectedMedicine?.cgst_sgst_price || "0.00",
      igst_price: selectedMedicine?.igst_price || "0.00",
      ...pricing, // item_subtotal, item_cgst_amount, etc.
    }

    if (isEditingCustom) {
      const updatedCustomized = [...customizedPrescriptions]
      updatedCustomized[editCustomIndex] = newCustomized
      setCustomizedPrescriptions(updatedCustomized)
      setIsEditingCustom(false)
      setEditCustomIndex(null)
    } else {
      setCustomizedPrescriptions((prev) => [...prev, newCustomized])
    }

    // Reset form
    setFormData({
      medicine_id: "",
      medicineName: null,
      medicine_type: "",
      dose: "",
      frequency: "",
      quantity: "",
      howToTake: "",
      how_to_take_id: "",
      anupan: "",
      anupana_id: "",
      prescriptionDuration: "",
      validity: "",
      default_instructions: "",
      isExternal: false
    });
    setErrors({})
    setShowRow(false)
  }

  const handleSave = () => {
    const newErrors = {}
    if (!formData.medicineName) newErrors.medicineName = "Medicine is required."
    if (!formData.dose.trim()) newErrors.dose = "Dose is required."
    if (!formData.frequency.trim()) newErrors.frequency = "Frequency is required."
    // 🔥 FIX: show duration error instead of quantity
    if (!duration && !formData.prescriptionDuration?.trim()) {
      newErrors.quantity = "Please select prescription duration first"
    } else if (!formData.quantity || Number(formData.quantity) <= 0) {
      newErrors.quantity = "Quantity is required."
    }
    if (!formData.how_to_take_id && !formData.howToTake.trim()) {
      newErrors.howToTake = "How to take is required.";
    }

    setErrors(newErrors)
    if (Object.keys(newErrors).length > 0) return

    const selectedMedicine = medicines.find((m) => String(m.medicine_id) === formData.medicineName.value)
    const pricing = calculateMedicinePrice(selectedMedicine, formData.quantity)

    const updatedPrescription = {
      medicine_id: formData.medicineName.value,
      medicineName: formData.medicineName.label,
      medicine_type: formData.medicine_type,
      default_dose_id: formData.default_dose_id,      // ADD
      default_frequency_id: formData.default_frequency_id,  // ADD
      package_qty: formData.package_qty,              // ADD
      dose: formData.dose,
      frequency: formData.frequency,
      quantity: formData.quantity,
      howToTake: formData.howToTake,
      how_to_take_id: formData.how_to_take_id || "",
      isExternal: formData.isExternal || false,

      anupan: formData.anupan,
      anupana_id: formData.anupana_id || null,

      base_price: selectedMedicine?.base_price || "0.00",
      CGST: selectedMedicine?.CGST || "0",
      SGST: selectedMedicine?.SGST || "0",
      IGST: selectedMedicine?.IGST || "0",
      cgst_sgst_price: selectedMedicine?.cgst_sgst_price || "0.00",
      igst_price: selectedMedicine?.igst_price || "0.00",
      ...pricing, // This will overwrite item_subtotal, item_cgst_amount, etc.
    }

    console.log("Medicine updated", updatedPrescription)

    if (isEditing) {
      const updatedPrescriptions = [...modifiedPrescriptions]
      updatedPrescriptions[editIndex] = updatedPrescription
      setModifiedPrescriptions(updatedPrescriptions)
      setIsEditing(false)
      setEditIndex(null)
    } else {
      const newIndex = modifiedPrescriptions.length
      setModifiedPrescriptions((prev) => [...prev, updatedPrescription])
      setSelectedPrescriptions((prev) => [...prev, newIndex])
    }

    setFormData({
      diseaseName: [],
      prescriptionDuration: "",
      isRegularServiceCall: true,
      frequencyDays: "",
      medicine_id: "",
      medicineName: null,
      medicine_type: "",
      dose: "",
      frequency: "",
      quantity: "",
      howToTake: "",
      how_to_take_id: "",
      anupan: "",
      anupana_id: "",
      base_price: "",
      CGST: "",
      SGST: "",
      IGST: "",
      cgst_sgst_price: "",
      igst_price: "",
      item_subtotal: "",
      item_cgst_amount: "",
      item_sgst_amount: "",
      item_igst_amount: "",
      item_gst_price: "",
      item_igst_price: "",
      validity: "",
      default_instructions: "",
      isExternal: false
    });
    // setDuration(null)
    // setValidity(null)
    setErrors({})
    setShowRow(false)
  }

  console.log("ji:", modifiedPrescriptions);
  // const handleEditClick = (index) => {
  //   const item = modifiedPrescriptions[index]
  //   setFormData((prev) => ({
  //     ...prev,
  //     medicineName: {
  //       value: item.medicine_id,
  //       label: item.medicineName,
  //     },
  //     medicine_type: item.medicine_type, // Ensure medicine_type is set
  //     dose: item.dose,
  //     frequency: item.frequency,
  //     quantity: item.quantity,
  //     howToTake: item.howToTake,
  //   }))
  //   setEditIndex(index)
  //   setIsEditing(true)
  //   setShowCustomMedicineTable(false) // Reset custom medicine state
  //   setIsEditingCustom(false) // Reset custom editing state
  //   setShowRow(true)
  // }

  // const handleEditClick = (index) => {
  //   const item = modifiedPrescriptions[index];

  //   setFormData((prev) => ({
  //     ...prev,                                                 // always use callback
  //     medicineName: item.medicineName
  //       ? { value: item.medicine_id, label: item.medicineName }
  //       : null,
  //     medicine_type: item.medicine_type ?? "",
  //     dose: item.dose ?? "",
  //     frequency: item.frequency ?? "",
  //     quantity: item.quantity ?? "",
  //     howToTake: item.howToTake ?? "",
  //     anupan: item.anupan ?? "",
  //   }));

  //   setEditIndex(index);
  //   setIsEditing(true);
  //   setShowRow(false);

  //   setShowCustomMedicineTable(false);
  //   setIsEditingCustom(false);
  //};handleEditClick
  const handleEditClick = (index) => {
    const item = modifiedPrescriptions[index];
    if (item.is_custom === "Yes") {
      const customIndex = customizedPrescriptions.findIndex(
        (c) => String(c.medicine_id) === String(item.medicine_id)
      );

      setIsEditingCustom(true);          // 🔥 MUST
      setEditCustomIndex(customIndex);   // 🔥 MUST

      const customItem = customizedPrescriptions[customIndex];

      setFormData({
        ...customItem,
        medicineName: {
          value: customItem.medicine_id,
          label: customItem.medicineName,
        },
      });

      return;
    }
    // 🔥 Find matching option IDs from label
    const doseObj = doseOptions.find(d => d.label === item.dose);
    const freqObj = frequencyOptions.find(f => f.label === item.frequency);
    const howObj = howToTakeOptionsWithOther.find(h => h.label === item.howToTake);
    const anupanObj = anupans.find(a => a.label === item.anupan);

    setFormData({
      medicine_id: item.medicine_id,
      medicineName: {
        value: item.medicine_id,
        label: item.medicineName
      },

      medicine_type: item.medicine_type || "",

      // ✅ LABEL
      dose: item.dose || "",
      frequency: item.frequency || "",
      howToTake: item.howToTake || "",
      anupan: item.anupan || "",

      // ✅ ID (IMPORTANT)
      // default_dose_id: doseObj?.value || "",
      // default_frequency_id: freqObj?.value || "",
      // how_to_take_id: howObj?.value || "",

      default_dose_id: item.default_dose_id || "",
      default_frequency_id: item.default_frequency_id || "",
      package_qty: item.package_qty || "1",
      how_to_take_id: item.how_to_take_id || "",
      anupana_id: anupanObj?.value || "",
      // package_qty: item.package_qty,
      quantity: item.quantity || "",
      package_qty: item.package_qty || "1",

      isExternal: item.isExternal || false,
      // treatmentType: item.treatmentType || "",
      treatmentType: item.is_custom === "Yes" ? "customMedicine" : "",
      prescriptionDuration:
        item.is_custom === "Yes"
          ? Number(item.custom_duration_in_days || "")
          : "",
      // prescriptionDuration: item.prescriptionDuration || "",
    });

    setEditIndex(index);
    setIsEditing(false);
    setShowRow(false); // 🔥 hide top form
  };

  const handleInlineUpdate = (index) => {
    // 🔥 ensure duration is selected before updating
    if (!duration && !formData.prescriptionDuration?.trim()) {
      setErrors(prev => ({ ...prev, quantity: "Please select prescription duration first" }));
      return;
    }

    const updated = [...modifiedPrescriptions];

    updated[index] = {
      ...updated[index],

      // medicine_id: formData.isExternal
      //   ? null
      //   : formData.medicineName?.value,

      medicine_id: formData.medicineName?.value || "",

      is_external: formData.isExternal ? "Yes" : "No",

      medicineName:
        typeof formData.medicineName === "object"
          ? formData.medicineName.label
          : formData.medicineName,

      medicine_type:
        typeof formData.medicine_type === "object"
          ? formData.medicine_type.label
          : formData.medicine_type,
      howToTake:
        typeof formData.howToTake === "object"
          ? formData.howToTake.label
          : formData.howToTake,

      anupan:
        typeof formData.anupan === "object"
          ? formData.anupan.label
          : formData.anupan,

      dose:
        typeof formData.dose === "object"
          ? formData.dose.label
          : formData.dose,

      frequency:
        typeof formData.frequency === "object"
          ? formData.frequency.label
          : formData.frequency,

      quantity: formData.quantity,

      // ✅ IMPORTANT
      // howToTake: formData.howToTake,
      // how_to_take_id: formData.how_to_take_id,   // 🔥 ADD THIS

      // anupan: formData.anupan,
      // anupana_id: formData.anupana_id,
      // 🔥 ADD THIS

      default_dose_id: formData.default_dose_id,         // 🔥 ADD
      default_frequency_id: formData.default_frequency_id, // 🔥 ADD

      package_qty: formData.package_qty,
      isExternal: formData.isExternal,
      treatmentType: formData.treatmentType,
      prescriptionDuration: formData.prescriptionDuration,
    };

    setModifiedPrescriptions(updated);

    // CLOSE INLINE EDITING
    setEditIndex(null);
    setIsEditing(false);

    // RESET FORM
    setFormData({
      medicine_id: null,
      medicineName: "",
      medicine_type: "",
      dose: "",
      frequency: "",
      quantity: "",
      howToTake: "",
      anupan: "",
      isExternal: false,
      treatmentType: "",
      validity: "",
      prescriptionDuration: "",
    });

    scrollToTable();
  };

  const initialFormData = {
    diseaseName: [],
    prescriptionDuration: "",
    isRegularServiceCall: true,
    frequencyDays: "",

    medicine_id: "",
    medicineName: null,
    medicine_type: "",

    dose: "",
    frequency: "",
    quantity: "",

    howToTake: "",
    how_to_take_id: "",

    anupan: "",
    anupana_id: "",

    base_price: "",
    CGST: "",
    SGST: "",
    IGST: "",
    cgst_sgst_price: "",
    igst_price: "",

    item_subtotal: "",
    item_cgst_amount: "",
    item_sgst_amount: "",
    item_igst_amount: "",
    item_gst_price: "",
    item_igst_price: "",

    default_dose_id: "",
    default_frequency_id: "",
    package_qty: "",

    treatmentType: "",
    isExternal: false
  };

  const handleDiscard = () => {
    setFormData(initialFormData);   // ✅ clean reset
    setIsEditing(false);
    setEditIndex(null);
    setIsEditingCustom(false);
    setEditCustomIndex(null);
    setShowCustomMedicineTable(false);
    setErrors({});
    setShowRow(false);
  };

  const handleOnDelete = (index) => {
    const updatedPrescriptions = [...modifiedPrescriptions]
    updatedPrescriptions.splice(index, 1)
    setModifiedPrescriptions(updatedPrescriptions)

    setSelectedPrescriptions((prev) => {
      return prev
        .filter((selectedIndex) => selectedIndex !== index) // Remove deleted index
        .map((selectedIndex) => (selectedIndex > index ? selectedIndex - 1 : selectedIndex)) // Adjust indices
    })
  }

  const handlePrescriptionSelect = (index, isChecked) => {
    setSelectedPrescriptions((prev) => {
      if (isChecked) {
        return [...prev, index]
      } else {
        return prev.filter((i) => i !== index)
      }
    })
  }

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      setSelectedPrescriptions(modifiedPrescriptions.map((_, index) => index))
    } else {
      setSelectedPrescriptions([])
    }
  }

  // Generate monthly prescription chunks (30-day blocks)
  const generateMonthlyChunks = (durationDays, medicines) => {
    const chunks = [];
    let month = 1;
    let start = 1;

    while (start <= durationDays) {
      let end = Math.min(start + 29, durationDays);

      chunks.push({
        month,
        start_day: start,
        end_day: end,
        medicines: medicines.map(med => ({
          ...med,
          month_duration: end - start + 1,
        })),
      });

      month++;
      start = end + 1;
    }

    return chunks;
  };


  const handleGeneratePrescription = async () => {
    if (isSubmitting) {
      console.log("Already submitting, please wait...")
      return
    }

    const patientId = patientDetails?.patient_id
    if (!patientId) {
      showErrorAlert("Patient ID not found")
      return
    }

    if (selectedPrescriptions.length === 0) {
      showErrorAlert("Please select at least one prescription to generate")
      return
    }
// ✅ ADD HERE
if (!pathyas || (Array.isArray(pathyas) && pathyas.length === 0)) {
  setErrors((prev) => ({
    ...prev,
    pathyas: "Please select pathya",
  }));
  return;
} else {
  setErrors((prev) => ({
    ...prev,
    pathyas: "",
  }));
}
    const selectedPrescriptionData = selectedPrescriptions.map((index) => modifiedPrescriptions[index])

    // if (!formData.diseaseName || formData.diseaseName.length === 0) {
    //   showErrorAlert("Please select at least one disease")
    //   return
    // }

    if (!duration) {
      showErrorAlert("Please select prescription duration")
      return
    }

    if (modifiedPrescriptions.length === 0) {
      showErrorAlert("Please add at least one medicine")
      return
    }

    setIsSubmitting(true)

    try {
      const selectedMedicines = modifiedPrescriptions.filter((_, index) => selectedPrescriptions.includes(index))

      // Validate and format medicines data
      // const formattedPrescriptions = selectedMedicines.map((item) => {
      //   return {
      //     medicine_id: item.medicine_id,
      //     medicine_name: item.medicineName,
      //     medicine_type: item.medicine_type,
      //     dose: item.dose || "",
      //     frequency: item.frequency || "",

      //     // ✅ SEND BOTH
      //     qty: item.quantity || item.qty || 1,
      //     quantity: item.quantity || item.qty || 1,

      //     howToTake: item.howToTake || "",
      //     how_to_take: item.how_to_take  || "",

      //     anupan: item.anupan || "",
      //     anupan_id: item.anupana_id || null,
      //     is_external: item.isExternal ? "Yes" : "No",
      //     base_price: item.base_price,
      //     CGST: item.CGST,
      //     SGST: item.SGST,
      //     IGST: item.IGST,
      //     cgst_sgst_price: item.cgst_sgst_price,
      //     igst_price: item.igst_price,
      //     item_subtotal: item.item_subtotal,
      //     item_cgst_amount: item.item_cgst_amount,
      //     item_sgst_amount: item.item_sgst_amount,
      //     item_igst_amount: item.item_igst_amount,
      //     item_gst_price: item.item_gst_price,
      //     item_igst_price: item.item_igst_price,
      //     is_external: item.isExternal === true ? "Yes" : "No",
      //     is_custom: "No",
      //     custom_duration_in_days: 0,
      //   }
      // })


      const formattedPrescriptions = selectedMedicines.map((item) => {
        const howToTakeObj = howToTakeOptions.find(
          h => String(h.value) === String(item.how_to_take_id)
        );

        const qty =
          item.quantity !== undefined && item.quantity !== null && item.quantity !== ""
            ? Number(item.quantity)
            : item.qty
              ? Number(item.qty)
              : 1;

        // 🔥 FIX: always get correct medicine
        const originalMedicine = medicines.find(
          m => String(m.medicine_id) === String(item.medicine_id)
        );

        const source = originalMedicine || item;

        const prices = calculateMedicinePrice(source, qty);

        return {
          medicine_id: item.medicine_id,
          medicine_name: item.medicineName,
          medicine_type: item.medicine_type,

          dose: item.dose || "",
          frequency: item.frequency || "",

          qty,
          quantity: qty,

          howToTake: item.howToTake || howToTakeObj?.label || "",
          how_to_take: item.howToTake || howToTakeObj?.label || "",

          anupan: item.anupan || "",
          anupan_id: item.anupana_id || item.anupan_id || null,

          // 🔥 FIXED PRICING
          base_price: source.base_price,
          CGST: source.CGST,
          SGST: source.SGST,
          IGST: source.IGST,

          cgst_sgst_price: source.cgst_sgst_price,
          igst_price: source.igst_price,

          ...prices,

          is_external: item.isExternal === true ? "Yes" : "No",
          is_custom: "No",
          custom_duration_in_days: 0,
        };
      });

      // Add custom medicines to the formatted prescriptions using same logic as regular medicines
      const customMedicines = customizedPrescriptions.map((item) => {
        const howToTakeObj = howToTakeOptions.find(
          h => String(h.value) === String(item.how_to_take_id)
        );

        if (!item.name) {
          throw new Error(`Invalid custom medicine data: ${JSON.stringify(item)}`)
        }

        return {
          medicine_id: item.medicine_id,
          medicine_name: item.name,
          medicine_type: item.medicine_type,
          dose: item.dose || "",
          frequency: item.frequency || "",

          // ✅ FIXED
          qty: item.quantity || 1,
          quantity: item.quantity || 1,

          howToTake: howToTakeObj?.label || item.howToTake || "",
          how_to_take: howToTakeObj?.label || item.howToTake || "",

          anupan: item.anupan || "",
          anupan_id: item.anupana_id || null,


          base_price: item.base_price,
          CGST: item.CGST,
          SGST: item.SGST,
          IGST: item.IGST,
          cgst_sgst_price: item.cgst_sgst_price,
          igst_price: item.igst_price,
          item_subtotal: item.item_subtotal,
          item_cgst_amount: item.item_cgst_amount,
          item_sgst_amount: item.item_sgst_amount,
          item_igst_amount: item.item_igst_amount,
          item_gst_price: item.item_gst_price,
          item_igst_price: item.item_igst_price,

          is_custom: "Yes",
          custom_duration_in_days: item.duration || 0,
        }
      })


      // Combine regular and custom medicines
      const allMedicines = [...formattedPrescriptions, ...customMedicines]

      const totalDays = parseInt(duration.value); // convert to number
      // const medicinesForChunking = [...selectedMedicines, ...customMedicines];
      // const chunked_months = generateMonthlyChunks(totalDays, medicinesForChunking);
      const chunked_months = generateMonthlyChunks(totalDays, allMedicines);

      console.log("Monthly Chunks:", chunked_months);
      console.log("chunked_months JSON:", JSON.stringify(chunked_months, null, 2));

      console.log("Formatted medicines:", formattedPrescriptions)
      console.log("Custom medicines:", customMedicines)
      console.log("All medicines:", allMedicines)

      const totals = calculateTotalFromMedicines(allMedicines)

      const disease_ids = Array.isArray(formData?.diseaseName)
        ? formData.diseaseName.map((option) => option.value)
        : [];

      const formattedDiseaseIds = disease_ids.join("|");

      const totalGST =
        totals.items_subtotal +
        totals.items_cgst_amount +
        totals.items_sgst_amount;

      const totalIGST =
        totals.items_subtotal +
        totals.items_igst_amount;
      //  Prepare prescription data with all required fields

      let finalDiscountAmount = 0;

      if (discountType === "percentage") {
        const percent = Number(discountPercentage || 0);
        finalDiscountAmount = (totals.items_subtotal * percent) / 100;
      } else if (discountType === "amount") {
        finalDiscountAmount = Number(discountAmount || 0);
      }
      const prescriptionPayload = {
        patient_id: patientId,
        duration: duration.value,
        prescription_validity_days: validity?.value,
        note: note || "",
        pathyas: Array.isArray(pathyas)
  ? pathyas.map(p => p.label).join(",")
  : pathyas?.label || "",

pathya_id: Array.isArray(pathyas)
  ? pathyas.map(p => p.value).join(",")
  : pathyas?.value || "",
        medicine_arr: JSON.stringify(allMedicines),
        chunked_months: JSON.stringify(chunked_months),// Use combined medicines array
        disease_ids: formattedDiseaseIds,
        items_subtotal: totals.items_subtotal.toFixed(2),
        items_cgst_amount: totals.items_cgst_amount.toFixed(2),
        items_sgst_amount: totals.items_sgst_amount.toFixed(2),
        items_igst_amount: totals.items_igst_amount.toFixed(2),
        gst_price: totalGST.toFixed(2),
        igst_price: totalIGST.toFixed(2),
        panchakarma_recommended: panchakarmaRecommended ? "YES" : "NO",
        discount_type: discountType || "none",
        discount_percentage:
          discountType === "percentage" ? discountPercentage || 0 : 0, // optional

        discount_amount:
          discountType === "percentage"
            ? discountPercentage || 0
            : discountAmount || 0,
        // prescription_validity: prescriptionValidity || 30,
      }

      console.log("Final prescription payload:", prescriptionPayload)
      console.log("Final prescription payload:", JSON.stringify(prescriptionPayload, null, 2));
      //  Call the API
      // const result = await dispatch(createPrescriptionAction(prescriptionPayload))
      let result;

      if (editingPrescriptionId) {
        // 🔥 UPDATE API CALL
        // const prices = calculateMedicinePrice(item, qty);
        result = await dispatch(
          updatePrescriptionAction({
            ...prescriptionPayload,
            prescription_id: editingPrescriptionId,
          })
        );
      } else {
        // 🔥 CREATE API CALL
        result = await dispatch(createPrescriptionAction(prescriptionPayload));
      }
      if (result?.success || result === true) {
        handleSuccess(
          editingPrescriptionId
            ? "Prescription updated successfully"
            : "Prescription created successfully"
        );
        // Reset form after successful creation
        setEditingPrescriptionId(null);
        setModifiedPrescriptions([])
        setCustomizedPrescriptions([]) // Reset custom medicines as well
        setNote("")
        setPathyas("")
        setDuration(null)
        setValidity(null)
        setFormData({
          diseaseName: [],
          medicineName: null,
          medicine_type: null,
          dose: "",
          frequency: "",
          quantity: "",
          howToTake: "",
          base_price: "",
          CGST: "",
          SGST: "",
          IGST: "",
          cgst_sgst_price: "",
          igst_price: "",
          item_subtotal: "",
          item_cgst_amount: "",
          item_sgst_amount: "",
          item_igst_amount: "",
          item_gst_price: "",
          item_igst_price: "",
        })
      }
    } catch (error) {
      console.error("Prescription creation error:", error)
      //  Show specific error message
      const errorMessage = error.response?.data?.message || error.message || "Failed to create prescription"
      showErrorAlert(errorMessage)
    } finally {
      setIsSubmitting(false) // Reset loading state
    }
  }

  useEffect(() => {
    console.log("Selected Prescription Data:", selectedPrescription)
  }, [selectedPrescription])

  useEffect(() => {
    if (selectedPrescription) {
      setFormData({
        pathyas: selectedPrescription.pathyas || "",
        pathya_id: selectedPrescription.pathya_id || "",
        validity: selectedPrescription.prescription_validity_days || "",
        discountType: selectedPrescription.discount_type || "",
        discountAmount: selectedPrescription.discount_amount || "",
      });
    }
  }, [selectedPrescription]);

  const handleOpenPrescriptionModal = async () => {
    console.log("Opening prescription modal...")
    try {
      const patientId = patientDetails?.patient_id
      console.log("Patient ID:", patientId)
      if (!patientId) {
        console.error("No patient ID found")
        showErrorAlert("Patient ID not found")
        return
      }

      // Always fetch fresh data when opening the modal
      console.log("Dispatching getPatientPrescriptionsAction...")
      await dispatch(getPatientPrescriptionsAction({ patient_id: patientId }))

      // Only show modal after data is fetched
      setHistoryModalVisible(true)
      console.log("Modal should be visible now")
    } catch (error) {
      console.error("Error in handleOpenPrescriptionModal:", error)
      showErrorAlert("Failed to load prescription history")
    }
  }

  // useEffect(() => {
  //   if (!formData.medicine_id) return;

  //   const doseObj = doseOptions.find(
  //     o => String(o.value) === String(formData.default_dose_id)
  //   );

  //   const freqObj = frequencyOptions.find(
  //     o => String(o.value) === String(formData.default_frequency_id)
  //   );

  //   const dose = doseObj?.numeric || 1;
  //   const frequency = freqObj?.numeric || 1;
  //   const durationDays = getTotalDays(duration?.value);
  //   const packageQty = Number(formData.package_qty || 1);

  //   if (!durationDays) return;

  //   const totalRequired = dose * frequency * durationDays;
  //   const packagesNeeded = Math.ceil(totalRequired / packageQty);
  //   const finalTablets = packagesNeeded * packageQty;

  //   console.log("Dose:", dose);
  //   console.log("Frequency:", frequency);
  //   console.log("Days:", durationDays);
  //   console.log("Required:", totalRequired);
  //   console.log("Packages:", packagesNeeded);
  //   console.log("Final Tablets:", finalTablets);

  //   setFormData(prev => ({
  //     ...prev,
  //     quantity: String(packagesNeeded), // 🔥 this goes to backend
  //     calculated_required_tabs: totalRequired,
  //     calculated_final_tabs: finalTablets
  //   }));

  // }, [
  //   formData.default_dose_id,
  //   formData.default_frequency_id,
  //   duration,
  //   formData.package_qty
  // ]);

  useEffect(() => {

    // ❌ STOP calculation during edit
    const isInlineEditing = editIndex !== null;

    // if (editingPrescriptionId && !isAutoCalculated && !isInlineEditing) {
    //   console.log("⛔ Skipping calculation");
    //   return;
    // }

    // ✅ allow calculation during custom medicine edit
if (
  editingPrescriptionId &&
  !isAutoCalculated &&
  !isInlineEditing &&
  formData.treatmentType !== "customMedicine"
) {
  console.log("⛔ Skipping calculation");
  return;
}
    console.log("✅ Running calculation");

    const isCustom = formData.treatmentType === "customMedicine";

    const isValidDuration = isCustom
      ? formData.prescriptionDuration !== "" && formData.prescriptionDuration !== undefined
      : duration?.value;

    if (
      (formData.default_dose_id || formData.dose) &&
      (formData.default_frequency_id || formData.frequency) &&
      isValidDuration
    ) {
      const doseObj = doseOptions.find(
        d => String(d.value) === String(formData.default_dose_id)
      );

      const freqObj = frequencyOptions.find(
        f => String(f.value) === String(formData.default_frequency_id)
      );

      const doseNum =
        Number(doseObj?.numeric) ||
        Number(formData.dose) ||
        1;

      const freqNum =
        Number(freqObj?.numeric) ||
        extractNumber(formData.frequency) ||
        1;

      let totalDays;

      if (isCustom) {
        totalDays = Number(formData.prescriptionDuration);
      } else {
        totalDays = getTotalDays(Number(duration?.value));
      }

      if (!totalDays || isNaN(totalDays)) {
        setFormData(prev => ({
          ...prev,
          quantity: "",
          calculated_required_tabs: "",
          calculated_final_tabs: ""
        }));
        return;
      }

      const requiredTabs = doseNum * freqNum * totalDays;

      // ✅ CORRECT
      const packQty = Number(formData.package_qty) || 1;

      const packagesNeeded = Math.ceil(requiredTabs / packQty);

      const finalTabs = packagesNeeded * packQty;

      setFormData(prev => {
        const updated = {
          ...prev,
          quantity: packagesNeeded,
          calculated_required_tabs: requiredTabs,
          calculated_final_tabs: finalTabs
        };

        // 🔥 also update table live
        if (editIndex !== null) {
          setModifiedPrescriptions(prevList => {
            const copy = [...prevList];
            copy[editIndex] = {
              ...copy[editIndex],
              quantity: packagesNeeded
            };
            return copy;
          });
        }

        return updated;
      });
    }

  }, [
    formData.default_dose_id,
    formData.default_frequency_id,
    formData.dose,              // 🔥 ADD
    formData.frequency,
    formData.prescriptionDuration,
    duration,
    formData.package_qty,
    formData.treatmentType,
    // isEditing // 👈 important
    isAutoCalculated,
    editIndex
  ]);

  const handleViewClick = (prescription) => {
    console.log("=== HANDLE VIEW CLICK IN PATIENT PRESCRIPTION ===")
    console.log("Selected Prescription for Detail View:", prescription)
    console.log("Medicines in selected prescription:", prescription.medicines)
    if (prescription.medicines && prescription.medicines.length > 0) {
      prescription.medicines.forEach((med, index) => {
        console.log(`Medicine ${index} in handleViewClick:`, {
          medicine_id: med.medicine_id,
          type: typeof med.medicine_id,
          medicine_name: med.medicine_name,
          full_object: med,
        })
      })
    }

    setSelectedPrescription(prescription)
    setDetailModalVisible(true)
  }
  // const handleEditClickFromHistory = (prescription) => {

  //   console.log("=== EDIT PRESCRIPTION FROM HISTORY ===");
  //   console.log("Prescription:", prescription);

  //   // 1. Load medicines into table
  //   setModifiedPrescriptions(prescription.medicines || []);

  //   // 2. Enable editing mode
  //   setIsEditing(true);

  //   // 3. Open the add/edit prescription block
  //   setShowRow(true);

  //   // 4. Close history modal
  //   setHistoryModalVisible(false);
  // };

  // const handleEditClickFromHistory = (prescription) => {


  //   const isCustom = (prescription.medicines || []).some(
  //     (med) => med.is_custom === "Yes"
  //   );

  //   // 🔥 IMPORTANT
  //   setTreatmentType(isCustom ? "customMedicine" : "");
  //   setShowCustomMedicineTable(isCustom);
  //   setIsEditingCustom(isCustom);

  //   console.log("EDIT FULL PRESCRIPTION:", prescription);

  //   // ✅ 1. Medicines
  //   setModifiedPrescriptions(
  //     (prescription.medicines || []).map((med) => {

  //       const doseObj = doseOptions.find(
  //         d => d.label === med.dose
  //       );

  //       const freqObj = frequencyOptions.find(
  //         f => f.label === med.frequency
  //       );

  //       const howObj = howToTakeOptions.find(
  //         h => h.label?.toLowerCase().trim() === med.how_to_take?.toLowerCase().trim()
  //       );

  //       const anupanObj = anupanOptions.find(
  //         a => a.label?.toLowerCase().trim() === med.anupan?.toLowerCase().trim()
  //       );

  //       return {
  //         medicine_id: med.medicine_id,
  //         medicineName: med.medicine_name,
  //         medicine_type:
  //           med.medicine_type ||
  //           med.medicineType ||
  //           medicines.find(m => String(m.medicine_id) === String(med.medicine_id))?.medicine_type ||
  //           "Not specified",

  //         dose: med.dose,
  //         frequency: med.frequency,
  //         quantity: med.qty,

  //         howToTake: med.how_to_take,

  //         how_to_take_id: howObj?.value || "",
  //         anupana_id: anupanObj?.value || "",

  //         default_dose_id: doseObj?.value || "",
  //         default_frequency_id: freqObj?.value || "",

  //         anupan: med.anupan,
  //         is_custom: med.is_custom,
  //         custom_duration_in_days: med.custom_duration_in_days,

  //         // 🔥 ADD THESE (IMPORTANT)
  //         base_price: med.base_price || 0,
  //         CGST: med.CGST || 0,
  //         SGST: med.SGST || 0,
  //         IGST: med.IGST || 0,

  //         cgst_sgst_price: med.cgst_sgst_price || 0,
  //         igst_price: med.igst_price || 0,

  //         item_subtotal: med.item_subtotal || 0,
  //         item_cgst_amount: med.item_cgst_amount || 0,
  //         item_sgst_amount: med.item_sgst_amount || 0,
  //         item_igst_amount: med.item_igst_amount || 0,
  //         item_gst_price: med.item_gst_price || 0,
  //         item_igst_price: med.item_igst_price || 0,
  //       };
  //     })
  //   );

  //   // if (isCustom) {
  //   //   setShowCustomMedicineTable(true);
  //   // } else {
  //   //   setShowCustomMedicineTable(false);
  //   // }

  //   // ✅ 2. Notes
  //   setNote(prescription.note || "");

  //   // ✅ 3. Pathyas
  //   // ✅ Pathyas FIX
  //   if (prescription.pathyas) {
  //     const matchedPathya = pathyaOptions.find(
  //       p => String(p.value) === String(prescription.pathya_id)
  //     );

  //     setPathyas(matchedPathya || null);
  //   }

  //   // ✅ 4. Duration (IMPORTANT)
  //   if (prescription.duration) {
  //     const selectedDuration = durationOptions.find(
  //       d => String(d.value) === String(prescription.duration)
  //     );
  //     setDuration(selectedDuration || null);
  //   }

  //   // ✅ 5. Validity
  //   const validityValue =
  //     prescription.prescription_validity_days ||
  //     prescription.validity ||
  //     null;

  //   if (validityValue) {
  //     const selectedValidity = validityOptions.find(
  //       v => String(v.value) === String(validityValue)
  //     );
  //     setValidity(selectedValidity || null);
  //   } else {
  //     setValidity(null); // optional
  //   }

  //   // ✅ 6. Panchakarma
  //   setPanchakarmaRecommended(
  //     prescription.panchakarma_recommended === "YES"
  //   );

  //   // ✅ 7. Discount
  //   if (prescription.discount_type) {
  //     const type = prescription.discount_type.toLowerCase();

  //     if (type === "percentage") {
  //       setDiscountType("percentage");
  //       setDiscountPercentage(prescription.discount_amount || "");
  //     } else if (type === "amount") {
  //       setDiscountType("amount");
  //       setDiscountAmount(prescription.discount_amount || "");
  //     }
  //   } else {
  //     // 🔥 RESET if not present
  //     setDiscountType("");
  //     setDiscountPercentage("");
  //     setDiscountAmount("");
  //   }

  //   // UI control
  //   setIsEditing(true);
  //   setShowRow(false);
  //   setEditingPrescriptionId(prescription.prescriptionId);
  //   setHistoryModalVisible(false);
  // };
  const handleEditClickFromHistory = (prescription) => {

    console.log("EDIT FULL PRESCRIPTION:", prescription);

    const customMeds = [];
    const normalMeds = [];

    (prescription.medicines || []).forEach((med) => {
      if (med.is_custom === "Yes") {
        customMeds.push(med);
      } else {
        normalMeds.push(med);
      }
    });

    const isCustom = customMeds.length > 0;

    // 🔥 UI states
    setTreatmentType(isCustom ? "customMedicine" : "");
    setShowCustomMedicineTable(isCustom);
    setIsEditingCustom(isCustom);
    // setEditIndex(null);        // normal edit बंद
    // setEditCustomIndex(null);  // reset (optional safe)

    // =========================
    // ✅ NORMAL MEDICINES
    // =========================
    setModifiedPrescriptions(
      normalMeds.map((med) => {

        const doseObj = doseOptions.find(d => d.label === med.dose);
        const freqObj = frequencyOptions.find(f => f.label === med.frequency);

        const howObj = howToTakeOptions.find(
          h => h.label?.toLowerCase().trim() === med.how_to_take?.toLowerCase().trim()
        );

        const anupanObj = anupanOptions.find(
          a => a.label?.toLowerCase().trim() === med.anupan?.toLowerCase().trim()
        );

        return {
          medicine_id: med.medicine_id,
          medicineName: med.medicine_name,

          medicine_type:
            med.medicine_type ||
            med.medicineType ||
            medicines.find(m => String(m.medicine_id) === String(med.medicine_id))?.medicine_type ||
            "Not specified",

          dose: med.dose,
          frequency: med.frequency,
          quantity: med.qty,

          howToTake: med.how_to_take,

          how_to_take_id: howObj?.value || "",
          // anupana_id: anupanObj?.value || "",

          default_dose_id: doseObj?.value || "",
          default_frequency_id: freqObj?.value || "",

          anupan: med.anupan,

          anupana_id: med.anupan_id || anupanObj?.value || "",

          package_qty: med.package_qty || 1,

          base_price: med.base_price || 0,
          CGST: med.CGST || 0,
          SGST: med.SGST || 0,
          IGST: med.IGST || 0,

          cgst_sgst_price: med.cgst_sgst_price || 0,
          igst_price: med.igst_price || 0,

          item_subtotal: med.item_subtotal || 0,
          item_cgst_amount: med.item_cgst_amount || 0,
          item_sgst_amount: med.item_sgst_amount || 0,
          item_igst_amount: med.item_igst_amount || 0,
          item_gst_price: med.item_gst_price || 0,
          item_igst_price: med.item_igst_price || 0,
        };
      })
    );

    // =========================
    // 🔥 CUSTOM MEDICINES (KEY FIX)
    // =========================
    setCustomizedPrescriptions(
      customMeds.map((med) => ({
        medicine_id: med.medicine_id,
        name: med.medicine_name,
        medicine_type: med.medicine_type,
        dose: med.dose,
        frequency: med.frequency,
        quantity: med.qty,
        howToTake: med.how_to_take,
        anupan: med.anupan,
        duration: med.custom_duration_in_days,

        base_price: med.base_price || 0,
        CGST: med.CGST || 0,
        SGST: med.SGST || 0,
        IGST: med.IGST || 0,

        item_subtotal: med.item_subtotal || 0,
        item_cgst_amount: med.item_cgst_amount || 0,
        item_sgst_amount: med.item_sgst_amount || 0,
        item_igst_amount: med.item_igst_amount || 0,
        item_gst_price: med.item_gst_price || 0,
        item_igst_price: med.item_igst_price || 0,
      }))
    );

    // =========================
    // बाकी same
    // =========================

    setNote(prescription.note || "");

    if (prescription.pathyas) {
      const matchedPathya = pathyaOptions.find(
        p => String(p.value) === String(prescription.pathya_id)
      );
      setPathyas(matchedPathya || null);
    }

    if (prescription.duration) {
      const selectedDuration = durationOptions.find(
        d => String(d.value) === String(prescription.duration)
      );
      setDuration(selectedDuration || null);
    }

    const validityValue =
      prescription.prescription_validity_days ||
      prescription.validity ||
      null;

    if (validityValue) {
      const selectedValidity = validityOptions.find(
        v => String(v.value) === String(validityValue)
      );
      setValidity(selectedValidity || null);
    } else {
      setValidity(null);
    }

    setPanchakarmaRecommended(
      prescription.panchakarma_recommended === "YES"
    );

    if (prescription.discount_type) {
      const type = prescription.discount_type.toLowerCase();

      if (type === "percentage") {
        setDiscountType("percentage");
        setDiscountPercentage(prescription.discount_amount || "");
      } else if (type === "amount") {
        setDiscountType("amount");
        setDiscountAmount(prescription.discount_amount || "");
      }
    } else {
      setDiscountType("");
      setDiscountPercentage("");
      setDiscountAmount("");
    }

    setIsEditing(true);
    setShowRow(false);
    setEditingPrescriptionId(prescription.prescriptionId);
    setHistoryModalVisible(false);
    setIsAutoCalculated(false); // 👈 important
  };

  console.log("PATHYAS STATE:", pathyas);
  console.log("VALIDITY STATE:", validity);
  console.log("DISCOUNT TYPE:", discountType);
  console.log("DISCOUNT %:", discountPercentage);
  console.log("DISCOUNT AMOUNT:", discountAmount);
  const handleDragStart = (e, index, isSubOption = false, subKey = null) => {
    const dragData = {
      index: index,
      isSubOption: isSubOption,
      subKey: subKey,
    }
    e.dataTransfer.setData("text/plain", JSON.stringify(dragData))
  }

  const handleDrop = (e, dropIndex, isSubOption = false, parentIndex = null) => {
    e.preventDefault()
    const dragDataStr = e.dataTransfer.getData("text/plain")
    if (!dragDataStr) return

    try {
      const dragData = JSON.parse(dragDataStr)

      if (dragData.isSubOption && isSubOption && parentIndex !== null) {
        const updated = [...mainOptions]
        const parentOption = updated[parentIndex]

        // Convert subs object to array of entries for easier reordering
        const subEntries = Object.entries(parentOption.subs)

        // Remove the dragged item and insert it at the new position
        const [draggedEntry] = subEntries.splice(dragData.index, 1)
        subEntries.splice(dropIndex, 0, draggedEntry)

        // Convert back to object with new order
        const newSubs = Object.fromEntries(subEntries)

        parentOption.subs = newSubs
        setMainOptions(updated)

        // Update the corresponding state
        if (parentIndex === 0) setVirechanSubs({ ...newSubs })
        else if (parentIndex === 1) setVimanSubs({ ...newSubs })
        else if (parentIndex === 2) setBastiSubs({ ...newSubs })
      } else if (!dragData.isSubOption && !isSubOption) {
        // Reordering main options
        const updated = [...mainOptions]
        const [removed] = updated.splice(dragData.index, 1)
        updated.splice(dropIndex, 0, removed)
        setMainOptions(updated)
      }
    } catch (error) {
      console.error("Error parsing drag data:", error)
    }
  }

  const handleSubDragStart = (e, parentIndex, subKey) => {
    e.dataTransfer.setData("parentIndex", parentIndex)
    e.dataTransfer.setData("subKey", subKey)
  }

  const handleSubDrop = (e, parentIndex, dropSubKey) => {
    e.preventDefault()
    const dragParentIndex = Number.parseInt(e.dataTransfer.getData("parentIndex"))
    const dragSubKey = e.dataTransfer.getData("subKey")

    if (dragParentIndex !== parentIndex) return // only reorder within same parent

    const updated = [...mainOptions]
    const subs = Object.keys(updated[parentIndex].subs)

    // reorder inside suboptions
    const dragIndex = subs.indexOf(dragSubKey)
    const dropIndex = subs.indexOf(dropSubKey)

    subs.splice(dropIndex, 0, subs.splice(dragIndex, 1)[0])

    // rebuild subs object with new order
    const reorderedSubs = {}
    subs.forEach((key) => {
      reorderedSubs[key] = updated[parentIndex].subs[key]
    })
    updated[parentIndex].subs = reorderedSubs

    setMainOptions(updated)
  }

  const allowDrop = (e) => {
    e.preventDefault()
  }
  const DoctorOnly = ({ children, tooltip }) => {
    const role = currentUser?.role_name;

    if (role === "Doctor") {
      return children; // allow as-is
    }

    return (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-disabled">{tooltip}</Tooltip>}
      >
        <span className="d-inline-block w-100">{children}</span>
      </OverlayTrigger>
    );
  };
  // const DOSE_OPTIONS = [
  //   { value: "1", label: "1" },
  //   { value: "1/2", label: "1/2" },
  //   { value: "2", label: "2" },
  //   { value: "5gm", label: "5 gm" },
  //   { value: "10ml", label: "10 ml" },
  // ];

  // const FREQUENCY_OPTIONS = [
  //   { value: "OD", label: "OD - Once a day" },
  //   { value: "BD", label: "BD - Twice a day" },
  //   { value: "TDS", label: "TDS - Three times a day" },
  //   { value: "HS", label: "HS - At bedtime" },
  // ];

  // const HOW_TO_TAKE_OPTIONS = [
  //   { value: "After Meal", label: "After Meal" },
  //   { value: "Before Meal", label: "Before Meal" },
  //   { value: "Empty Stomach", label: "Empty Stomach" },
  //   { value: "With Warm Water", label: "With Warm Water" },
  // ];

  // const ANUPAN_OPTIONS = [
  //   { value: "Warm Water", label: "Warm Water" },
  //   { value: "Honey", label: "Honey" },
  //   { value: "Ghee", label: "Ghee" },
  //   { value: "Milk", label: "Milk" },
  //   { value: "Warm Milk", label: "Warm Milk" },
  //   { value: "With Water", label: "With Water" },
  // ];

  const isMedicineSelected = !!formData.medicine_id;
  return (
    <>
      <div className="col-xl-12 ">
        <div className="card shadow-none">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-start flex-wrap mb-3">
              <div className="row flex-grow-1 gx-3" style={{ maxWidth: "800px" }}>
                {/* Disease Name */}
                {/* <div className="col-md-5 mb-3">
                  <label className="form-label mb-1">
                    Disease Name: <span className="text-danger">*</span>
                  </label>

                  <DoctorOnly tooltip="You don't have permission to edit this field">
                    <Select
                      isMulti
                      name="diseaseName"
                      options={diseases}
                      value={formData.diseaseName}
                      onChange={handleDiseaseChange}
                      placeholder="Select Disease(s)"
                      isDisabled={currentUser?.role_name !== "Doctor"}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          minHeight: "40px",
                          borderColor: state.isFocused ? "#007bff" : "#ced4da",
                          boxShadow: state.isFocused
                            ? "0 0 0 2px rgba(0, 123, 255, 0.25)"
                            : "none",
                          transition: "all 0.3s ease",
                          borderRadius: "5px",
                        }),
                        multiValue: (provided) => ({
                          ...provided,
                          backgroundColor: "#e0e0e0",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: () => ({
                          display: "none",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 11,
                        }),
                      }}
                    />
                  </DoctorOnly>

                  {errors.diseaseName && (
                    <small className="text-danger">{errors.diseaseName}</small>
                  )}
                </div> */}


                {/* Prescription Duration */}
                <div className="row">
                  {/* LEFT — Prescription Duration */}
                  <div className="col-md-5 mb-3">
                    <label className="form-label mb-1">Prescription Duration:</label>
                    <DoctorOnly tooltip="You don't have permission to edit this field">
                      <Select
                        name="duration"
                        options={durationOptions}
                        value={duration}
                        onChange={handleDurationChange}
                        placeholder="Select Duration"
                        isDisabled={currentUser?.role_name !== "Doctor"}
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            minHeight: "40px",
                            borderColor: state.isFocused ? "#007bff" : "#ced4da",
                            boxShadow: state.isFocused
                              ? "0 0 0 2px rgba(0, 123, 255, 0.25)"
                              : "none",
                            transition: "all 0.3s ease",
                            borderRadius: "5px",
                          }),
                          singleValue: (provided) => ({ ...provided, lineHeight: "40px" }),
                          dropdownIndicator: (provided) => ({ ...provided, padding: "4px" }),
                          indicatorSeparator: () => ({ display: "none" }),
                        }}
                      />
                    </DoctorOnly>
                  </div>

                  {/* MIDDLE — Prescription Validity */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label mb-1">Prescription Validity:</label>
                    <DoctorOnly tooltip="You don't have permission to edit this field">
                      <Select
                        name="validity"
                        options={validityOptions}
                        value={validity}
                        onChange={handleValidityChange}
                        placeholder="Select Validity"
                        isDisabled={currentUser?.role_name !== "Doctor"}
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            minHeight: "40px",
                            borderColor: state.isFocused ? "#007bff" : "#ced4da",
                            boxShadow: state.isFocused
                              ? "0 0 0 2px rgba(0, 123, 255, 0.25)"
                              : "none",
                            transition: "all 0.3s ease",
                            borderRadius: "5px",
                          }),
                          singleValue: (provided) => ({ ...provided, lineHeight: "40px" }),
                          dropdownIndicator: (provided) => ({ ...provided, padding: "4px" }),
                          indicatorSeparator: () => ({ display: "none" }),
                        }}
                      />
                    </DoctorOnly>
                  </div>

                  {/* RIGHT — Regular Service Call */}

                </div>


              </div>

              {/* Right Side - Icons and Button */}
              {/* <div className="d-flex align-items-center gap-2 mt-2 mt-md-0">
                <img
                  src={icon1 || "/placeholder.svg"}
                  alt="History Icon"
                  style={{
                    cursor: "pointer",
                    marginTop: "20px",
                    marginRight: "8px",
                    width: "36px",
                    height: "36px",
                    verticalAlign: "middle",
                  }}
                  onClick={handleOpenPrescriptionModal}
                  title="View Prescription History"
                />

{isDoctor ? (
                <Button
                  variant="primary"
                  onClick={() => {
                    setShowRow(true);
                    setTreatmentType(""); // Reset custom medicine selection
                    setShowCustomMedicineTable(false);
                  }}
                >
                  Add Medicine
                </Button>
              ) : (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-disabled">Only doctors can add medicines</Tooltip>}
                >
                  <span className="d-inline-block">
                    <Button
                      variant="primary"
                      disabled
                      style={{ pointerEvents: "none" }}
                    >
                      Add Medicine
                    </Button>
                  </span>
                </OverlayTrigger>
              )}
              </div> */}
              <div
                className="d-flex align-items-center justify-content-start flex-wrap gap-3 mt-3"
                style={{ lineHeight: 1 }}
              >
                {/* Prescription History Icon */}
                <img
                  src={icon1 || "/placeholder.svg"}
                  alt="History Icon"
                  title="View Prescription History"
                  onClick={handleOpenPrescriptionModal}
                  style={{
                    cursor: "pointer",
                    width: "36px",
                    height: "36px",
                    objectFit: "contain",
                  }}
                />

                {/* Add Medicine Button / Tooltip */}
                {isDoctor ? (
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className="d-flex align-items-center"
                    onClick={() => {
                      setShowRow(true);
                      scrollToTable();
                      setTreatmentType("");
                      setShowCustomMedicineTable(false);
                    }}
                  >

                    Add Medicine
                  </Button>
                ) : (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-disabled">Only doctors can add medicines</Tooltip>}
                  >
                    <span className="d-inline-block">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        disabled
                        style={{ pointerEvents: "none" }}
                        className="d-flex align-items-center"
                      >

                        Add Medicine
                      </Button>
                    </span>
                  </OverlayTrigger>
                )}
              </div>


            </div>

            <PrescriptionHistoryModal
              show={historyModalVisible}
              onHide={() => setHistoryModalVisible(false)}
              prescriptionData={prescriptionData}
              // rawPrescriptions={prescriptions}
              handleViewClick={handleViewClick}
              handleEditClick={handleEditClickFromHistory}
              patientDetails={patientDetails}
            />

            <PrescriptionDetailModal
              show={detailModalVisible}
              onHide={() => setDetailModalVisible(false)}
              selectedPrescription={selectedPrescription}
              patientDetails={patientDetails}
            />
            <div ref={tableRef}>
              {/* Fix: Show "Generate Prescription" button when table is empty */}
              {modifiedPrescriptions.length === 0 ? (
                <div className="text-center py-0"></div>
              ) : (
                <div
                  style={{
                    border: "2px solid #ddd",
                    borderRadius: "5px",
                    marginBottom: 0,
                  }}
                  className="table-responsive"
                >
                  <table
                    className="table header-border"
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                    }}
                  >
                    <thead
                      style={{
                        position: "sticky",
                        top: 0,
                        backgroundColor: "#f8f9fa",
                        //zIndex: 10,
                        borderBottom: "2px solid #ddd",
                      }}
                    >
                      <tr className="table-info">
                        <th
                          style={{
                            padding: "10px",
                            color: "black",
                            fontWeight: "bold",
                            width: "50px",
                          }}
                        >
                          {/* <input
                          type="checkbox"
                          checked={
                            selectedPrescriptions.length === modifiedPrescriptions.length &&
                            modifiedPrescriptions.length > 0
                          }
                          onChange={(e) => handleSelectAll(e.target.checked)}
                          style={{ transform: "scale(1.2)" }}
                        /> */}
                        </th>
                        <th
                          style={{
                            padding: "10px",
                            color: "black",
                            fontWeight: "bold",
                          }}
                        >
                          Medicine Name
                        </th>
                        <th
                          style={{
                            padding: "10px",
                            color: "black",
                            fontWeight: "bold",
                          }}
                        >
                          Medicine type
                        </th>
                        <th
                          style={{
                            padding: "10px",
                            color: "black",
                            fontWeight: "bold",
                          }}
                        >
                          Dose
                        </th>
                        <th
                          style={{
                            padding: "10px",
                            color: "black",
                            fontWeight: "bold",
                          }}
                        >
                          Frequency
                        </th>
                        <th
                          style={{
                            padding: "10px",
                            color: "black",
                            fontWeight: "bold",
                          }}
                        >
                          Quantity
                        </th>
                        <th
                          style={{
                            padding: "10px",
                            color: "black",
                            fontWeight: "bold",
                          }}
                        >
                          How to Take?
                        </th>
                        <th
                          style={{
                            padding: "10px",
                            color: "black",
                            fontWeight: "bold",
                          }}
                        > Anupan</th>
                        <th
                          style={{
                            padding: "10px",
                            color: "black",
                            fontWeight: "bold",
                          }}
                        > Action
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      {modifiedPrescriptions.map((prescription, index) => (
                        // <tr key={index}>
                        //   <td style={{ padding: "10px", textAlign: "center" }}>
                        //     <div className="form-check">
                        //       <input
                        //         type="checkbox"
                        //         className="form-check-input"
                        //         id={`prescription-${index}`}
                        //         checked={selectedPrescriptions.includes(index)}
                        //         onChange={(e) => handlePrescriptionSelect(index, e.target.checked)}
                        //       />
                        //     </div>
                        //   </td>
                        //   <td style={{ padding: "10px" }}>{prescription.medicineName}</td>
                        //   <td style={{ padding: "10px" }}>{prescription.medicine_type || "Not specified"}</td>
                        //   <td style={{ padding: "10px" }}>{prescription.dose}</td>
                        //   <td style={{ padding: "10px" }}>{prescription.frequency}</td>
                        //   <td style={{ padding: "10px" }}>{prescription.quantity}</td>
                        //   <td style={{ padding: "10px" }}>{prescription.howToTake}</td>
                        //   <td style={{ padding: "10px" }}>
                        //     <div className="d-flex justify-content-around">
                        //       <DoctorOnly tooltip="Only doctors can edit prescriptions">
                        //         <Link to="#" className="view detail me-4" onClick={() => handleEditClick(index)}>
                        //           <i className="fa fa-pencil-alt fs-18 text-success" aria-hidden="true"></i>
                        //         </Link>
                        //       </DoctorOnly>
                        //       <DoctorOnly tooltip="Only doctors can delete prescriptions">
                        //         <Link className="delete" onClick={() => handleOnDelete(index)} aria-label="Delete">
                        //           <i className="fa fa-trash fs-18 text-danger"></i>
                        //         </Link>
                        //       </DoctorOnly>
                        //     </div>
                        //   </td>
                        // </tr>
                        <tr key={index} style={{ background: "#f7f7f7" }}>
                          {editIndex === index ? (
                            <td colSpan="10" style={{ padding: "20px" }}>
                              <div
                                style={{
                                  background: "white",
                                  border: "1px solid #ddd",
                                  borderRadius: "10px",
                                  padding: "20px",
                                  display: "grid",
                                  gridTemplateColumns: "repeat(4, 1fr)",
                                  gap: "20px",
                                }}
                              >
                                {/* Medicine Name */}
                                <div>
                                  <label className="form-label fw-semibold">Medicine Name</label>

                                  {/* Dropdown: Uses MedicineDrop for lazy loading */}
                                  <MedicineDrop
                                    isMulti={false}
                                    value={formData.medicineName || null}
                                    medicineTypeFilter={formData.isExternal ? "External" : "Internal"}  
                                    excludeMedicineIds={modifiedPrescriptions
                                      .filter((_, index) => index !== editIndex)
                                      .map((item) => String(item.medicine_id))} 
                                    onChange={(selected) => {
                                      const selectedMedicine = medicines.find(
                                        (m) => String(m.medicine_id) === String(selected?.value)
                                      )

                                      if (!selectedMedicine) return

                                      const prices = calculateMedicinePrice(selectedMedicine, 1)

                                      setFormData((prev) => ({
                                        ...prev,

                                        medicine_id: selectedMedicine.medicine_id,
                                        medicineName: selected,

                                        // ✅ IDs for dropdown binding
                                        medicine_type_id: selectedMedicine.medicine_type_id,
                                        default_dose_id: selectedMedicine.default_dose_id,
                                        default_frequency_id: selectedMedicine.default_frequency_id,
                                        how_to_take_id: selectedMedicine.how_to_take_id || "",
                                        anupana_id: selectedMedicine.anupana_id || "",
                                        default_instructions: selectedMedicine?.default_instructions || "",

                                        // ✅ Labels for table display
                                        medicine_type: selectedMedicine.medicine_type_text || "",
                                        dose: selectedMedicine.dose_text || "",
                                        frequency: selectedMedicine.frequency_text || "",
                                        howToTake: selectedMedicine.how_to_take_text || "",
                                        anupan: selectedMedicine.anupana_text || "",
                                        package_qty: selectedMedicine.package_qty || "1",

                                        quantity: "1",

                                        // ✅ Pricing
                                        base_price: selectedMedicine.base_price,
                                        CGST: selectedMedicine.CGST,
                                        SGST: selectedMedicine.SGST,
                                        IGST: selectedMedicine.IGST,
                                        cgst_sgst_price: selectedMedicine.cgst_sgst_price,
                                        igst_price: selectedMedicine.igst_price,

                                        item_subtotal: prices.item_subtotal,
                                        item_cgst_amount: prices.item_cgst_amount,
                                        item_sgst_amount: prices.item_sgst_amount,
                                        item_igst_amount: prices.item_igst_amount,
                                        item_gst_price: prices.item_gst_price,
                                        item_igst_price: prices.item_igst_price,
                                      }))
                                      setSelectedMedicineUnit(selectedMedicine?.unit_text || "")
                                    }}
                                  />

                                  {/* Checkbox: External medicine mode */}
                                  <div className="d-flex align-items-center mt-2">
                                    <input
                                      type="checkbox"
                                      checked={formData.isExternal}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          isExternal: e.target.checked,
                                          medicine_id: null,
                                          medicineName: "",
                                        })
                                      }
                                      style={{ width: "16px", height: "16px", cursor: "pointer" }}
                                    />
                                    <span className="ms-2">External Medicine?</span>
                                  </div>

                                  {errors.medicineName && <small className="text-danger">{errors.medicineName}</small>}
                                </div>

                                {/* Medicine Type */}
                                <div>
                                  <label className="form-label fw-bold">Medicine Type</label>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={formData.medicine_type || ""}
                                    readOnly
                                    style={{
                                      backgroundColor: "#f5f5f5",
                                      cursor: "not-allowed",
                                    }}
                                  />

                                </div>

                                {/* Dose - with unit display */}
                                <div>
                                  <label className="form-label fw-bold">Dose</label>
                                  <Select
                                    options={doseOptions.map(opt => ({
                                      ...opt,
                                      label: selectedMedicineUnit ? `${opt.label} ${selectedMedicineUnit}` : opt.label
                                    }))}
                                    value={
                                      doseOptions.find(o => String(o.value) === String(formData.default_dose_id))
                                        ? {
                                            ...doseOptions.find(o => String(o.value) === String(formData.default_dose_id)),
                                            label: selectedMedicineUnit
                                              ? `${doseOptions.find(o => String(o.value) === String(formData.default_dose_id)).label} ${selectedMedicineUnit}`
                                              : doseOptions.find(o => String(o.value) === String(formData.default_dose_id)).label
                                          }
                                        : null
                                    }
                                    onChange={(selected) =>
                                      setFormData({
                                        ...formData,
                                        default_dose_id: selected.value,
                                        dose: selected.label,
                                      })
                                    }
                                  />

                                </div>

                                {/* Frequency */}
                                <div>
                                  <label className="form-label fw-bold">Frequency</label>
                                  <Select
                                    options={frequencyOptions}
                                    value={
                                      frequencyOptions.find(
                                        o => String(o.value) === String(formData.default_frequency_id)
                                      ) || null
                                    }
                                    onChange={(selected) =>
                                      setFormData({
                                        ...formData,
                                        default_frequency_id: selected.value,
                                        frequency: selected.label,
                                      })
                                    }
                                  />

                                </div>

                                {/* Quantity */}
                                <div>
                                  <label className="form-label fw-bold">Quantity</label>
                                  {/* <input
                                    type="text"
                                    name="quantity"
                                    value={formData.quantity}
                                    readOnly
                                    className="form-control form-control-sm"
                                  /> */}
                                    <input
    type="number"
    className="form-control form-control-sm"
    value={
      (() => {
        // Live calculation using current form data
        const doseNum = extractNumber(formData.dose) || 1;
        const freqNum = extractNumber(formData.frequency) || 1;
        const totalDays = Number(formData.prescriptionDuration) || 0;
        const packQty = Number(formData.package_qty) || 1;
        if (totalDays > 0 && packQty > 0) {
          return Math.ceil((doseNum * freqNum * totalDays) / packQty);
        }
        return formData.quantity || "";
      })()
    }
    readOnly
    style={{ backgroundColor: "#f5f5f5" }}
  />
                                </div>

                                {/* <small className="text-muted">
                                  Required: {formData.calculated_required_tabs || 0} tablets <br />
                                  Packaging: {formData.package_qty || 0} per pack <br />
                                  Giving: {formData.quantity || 0} packs ({formData.calculated_final_tabs || 0} tablets)
                                </small> */}

                                {/* How to Take */}
                                <div style={{ gridColumn: "span 2" }}>
                                  <label className="form-label fw-bold">How to Take</label>
                                  <Select
                                    options={howToTakeOptionsWithOther}
                                    value={
                                      howToTakeOptionsWithOther.find(
                                        o => o.value == formData.how_to_take_id
                                      ) || null
                                    }
                                    onChange={(selected) => {
                                      if (!selected) return;

                                      if (selected.value === "other") {
                                        setFormData(prev => ({
                                          ...prev,
                                          howToTake: "",
                                          how_to_take_id: "other"
                                        }))
                                      } else {
                                        setFormData(prev => ({
                                          ...prev,
                                          howToTake: selected.label,
                                          how_to_take_id: selected.value
                                        }))
                                      }
                                    }}
                                  />

                                  {formData.how_to_take_id === "other" && (
                                    <div className="position-relative mt-2">

                                      <textarea
                                        className="form-control pe-5 pb-4"
                                        rows="3"
                                        placeholder="Enter custom instructions"
                                        value={formData.howToTake}
                                        onChange={(e) =>
                                          setFormData(prev => ({
                                            ...prev,
                                            howToTake: e.target.value
                                          }))
                                        }
                                        style={{
                                          resize: "none",
                                          paddingBottom: "35px"   // 🔥 space for buttons inside
                                        }}
                                      />

                                      {/* 🔽 Bottom Inside Controls */}
                                      <div
                                        style={{
                                          position: "absolute",
                                          bottom: "6px",
                                          right: "8px",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                        }}
                                      >
                                        {/* 🌐 Language Toggle */}
                                        <button
                                          type="button"
                                          onClick={toggleSpeechLang}
                                          style={{
                                            padding: "2px 6px",
                                            borderRadius: "8px",
                                            border: "1px solid #ccc",
                                            background: "#fff",
                                            fontSize: "10px",
                                            height: "22px"
                                          }}
                                        >
                                          {speechLang === "en-IN" ? "EN" : "MR"}
                                        </button>

                                        {/* 🎙 Mic */}
                                        <button
                                          type="button"
                                          onClick={() =>
                                            startListening("howToTake", (prevText) =>
                                              setFormData(prev => ({
                                                ...prev,
                                                howToTake: prevText
                                              }))
                                            )
                                          }
                                          style={{
                                            width: "24px",
                                            height: "24px",
                                            borderRadius: "50%",
                                            border: "none",
                                            background: activeMic === "howToTake" ? "#ff4d4d" : "#f1f3f5",
                                            boxShadow:
                                              activeMic === "howToTake"
                                                ? "0 0 6px rgba(255,0,0,0.6)"
                                                : "0 2px 4px rgba(0,0,0,0.2)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <FaMicrophone
                                            size={12}
                                            color={activeMic === "howToTake" ? "white" : "#333"}
                                          />
                                        </button>
                                      </div>

                                    </div>
                                  )}
                                </div>

                                {/* Anupan */}
                                <div>
                                  <label className="form-label fw-bold">Anupan</label>
                                  <Select
                                    options={anupanOptions}  // ✅ FIX
                                    value={
                                      anupanOptions.find(
                                        o => String(o.value) === String(formData.anupana_id)
                                      ) ||
                                      anupanOptions.find(
                                        o =>
                                          o.label?.toLowerCase().trim() ===
                                          formData.anupan?.toLowerCase().trim()
                                      ) ||
                                      null
                                    }
                                    onChange={(selected) => {
                                      setFormData(prev => ({
                                        ...prev,
                                        anupan: selected?.label || "",
                                        anupana_id: selected?.value || null
                                      }))
                                    }}
                                  />

                                </div>

                                {formData.default_instructions && (
                                  <div className="mt-2 p-2" style={{
                                    background: "#f8f9fa",
                                    borderLeft: "3px solid #0d6efd",
                                    fontSize: "13px",
                                    borderRadius: "4px"
                                  }}>
                                    <label className="fw-bold mb-1 d-block">
                                      Default Instructions:
                                    </label>
                                    <span>{formData.default_instructions}</span>
                                  </div>
                                )}
                                {/* Custom Medicine Checkbox */}
                                <div style={{ gridColumn: "span 2", display: "flex", alignItems: "center", gap: "20px" }}>

                                  {/* Checkbox */}
                                  <div className="form-check d-flex align-items-center" style={{ gap: "8px" }}>
                                    <input
                                      className="form-check-input m-0"
                                      type="checkbox"
                                      checked={formData.treatmentType === "customMedicine"}
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          treatmentType: e.target.checked ? "customMedicine" : "",
                                        });
                                      }}
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        cursor: "pointer",
                                      }}
                                    />
                                    <label className="form-check-label fw-semibold mb-0">
                                      Custom Medicine
                                    </label>
                                  </div>

                                  {/* Duration */}
                                  {formData.treatmentType === "customMedicine" && (
                                    <input
                                      type="number"
                                      className="form-control"
                                      style={{ width: "120px" }}
                                      placeholder="Days"
                                      value={formData.prescriptionDuration}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          prescriptionDuration: e.target.value,
                                        })
                                      }
                                    />
                                  )}

                                </div>


                                {/* Buttons */}
                                <div style={{
                                  gridColumn: "span 2",
                                  display: "flex",
                                  justifyContent: "end",
                                  alignItems: "center",
                                  gap: "10px"
                                }}>
                                  <button
                                    className="btn btn-success"
                                    onClick={() => handleInlineUpdate(index)}
                                    disabled={!duration && !formData.prescriptionDuration}
                                  >
                                    Save
                                  </button>

                                  <button
                                    className="btn btn-outline-secondary"
                                    onClick={() => setEditIndex(null)}
                                  >
                                    Cancel
                                  </button>
                                </div>

                              </div>
                            </td>
                          ) : (
                            <>
                              <td style={{ padding: "10px" }}>
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={selectedPrescriptions.includes(index)}
                                    onChange={(e) => handlePrescriptionSelect(index, e.target.checked)}
                                  />
                                </div>
                              </td>

                              <td>{prescription.medicineName}</td>
                              <td>{prescription.medicine_type || "Not specified"}</td>
                              <td>{prescription.dose}</td>
                              <td>{prescription.frequency}</td>
                              <td>{prescription.quantity}</td>
                              <td>
                                {
                                  prescription.howToTake
                                  ||
                                  howToTakeOptionsWithOther.find(
                                    o => String(o.value) === String(prescription.how_to_take_id)
                                  )?.label
                                  ||
                                  "-"
                                }
                              </td>
                              <td>{prescription.anupan}</td>
                              <td>
                                <div className="d-flex justify-content-around">
                                  <DoctorOnly tooltip="Only doctors can edit prescriptions">
                                    <Link
                                      to="#"
                                      className="view detail me-4"
                                      onClick={() => handleEditClick(index)}
                                    >
                                      <i className="fa fa-pencil-alt fs-18 text-success"></i>
                                    </Link>
                                  </DoctorOnly>

                                  <DoctorOnly tooltip="Only doctors can delete prescriptions">
                                    <Link to="#" onClick={() => handleOnDelete(index)}>
                                      <i className="fa fa-trash fs-18 text-danger"></i>
                                    </Link>
                                  </DoctorOnly>
                                </div>
                              </td>
                            </>
                          )}
                        </tr>

                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <div className="d-flex justify-content-end mb-3" style={{ marginTop: "20px" }}>
              {/* <Button
                variant="primary"
                onClick={() => {
                  setShowRow(true)
                  setTreatmentType("") // Reset custom medicine selection
                  setShowCustomMedicineTable(false)
                }}
              >
                Add Medicine
              </Button>
            </div> */}
            </div>

            {showRow && (
              <div className="mb-3">
                <div
                  style={{
                    border: "2px solid #ddd",
                    borderRadius: "8px",
                    padding: "20px",
                    marginBottom: "40px",
                  }}
                >
                  <div className="row gy-1 gx-3">

                    {/* Medicine Name */}
                    <div className="col-xl-3 col-lg-6">
                      <label className="form-label fw-semibold">Medicine Names</label>

                      {/* Dropdown changes based on EXTERNAL toggle */}
                      {/* <Select
                        name="medicineName"
                        // options={
                        //   formData.isExternal
                        //     ? STATIC_MEDICINES
                        //     : medicines
                        //       .filter(
                        //         (m) =>
                        //           !modifiedPrescriptions.some(
                        //             (p) => String(p.medicine_id) === String(m.medicine_id)
                        //           )
                        //       )
                        //       .map((m) => ({
                        //         value: String(m.medicine_id),
                        //         label: m.medicine_name,
                        //       }))
                        // }
                        options={
                          formData.isExternal
                            ? externalMedicines.map((m) => ({
                              value: String(m.medicine_id),
                              label: m.medicine_name,
                            }))
                            : internalMedicines
                              .filter(
                                (m) =>
                                  !modifiedPrescriptions.some(
                                    (p) => String(p.medicine_id) === String(m.medicine_id)
                                  )
                              )
                              .map((m) => ({
                                value: String(m.medicine_id),
                                label: m.medicine_name,
                              }))
                        }

                        // value={
                        //   formData.isExternal
                        //     ? STATIC_MEDICINES.find((m) => m.value === formData.medicine_id) || null
                        //     : formData.medicineName
                        // }
                        value={formData.medicineName || null}

                        onChange={(selected) =>
                          setFormData({
                            ...formData,
                            medicine_id: selected?.value || null,
                            medicineName: selected || "",
                          })
                        }
                        placeholder="Select Medicine"
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            minHeight: "40px",
                            height: "40px",
                            borderColor: state.isFocused ? "#007bff" : "#ced4da",
                            boxShadow: state.isFocused
                              ? "0 0 0 2px rgba(0, 123, 255, 0.25)"
                              : "none",
                            transition: "all 0.3s ease",
                            borderRadius: "5px",
                            fontSize: "0.875rem",
                          }),
                          singleValue: (provided) => ({
                            ...provided,
                            lineHeight: "40px",
                          }),
                          dropdownIndicator: (provided) => ({
                            ...provided,
                            padding: "4px",
                          }),
                          indicatorSeparator: () => ({ display: "none" }),
                        }}
                      /> */}

                      <MedicineDrop
                        isMulti={false}
                        value={formData.medicineName || null}
                        medicineTypeFilter={formData.isExternal ? "External" : "Internal"}   
                        excludeMedicineIds={modifiedPrescriptions
                          .filter((_, index) => index !== editIndex)
                          .map((item) => String(item.medicine_id))}
                        onChange={(selected) => {
                          const selectedMedicine = medicines.find(
                            (m) => String(m.medicine_id) === String(selected?.value)
                          )

                          if (!selectedMedicine) return

                          const prices = calculateMedicinePrice(selectedMedicine, 1)

                          setFormData((prev) => ({
                            ...prev,

                            medicine_id: selectedMedicine.medicine_id,
                            medicineName: selected,

                            // ✅ IDs for dropdown binding
                            medicine_type_id: selectedMedicine.medicine_type_id,
                            default_dose_id: selectedMedicine.default_dose_id,
                            default_frequency_id: selectedMedicine.default_frequency_id,
                            how_to_take_id: selectedMedicine.how_to_take_id || "",
                            anupana_id: selectedMedicine.anupana_id || "",
                            default_instructions: selectedMedicine?.default_instructions || "",

                            // ✅ Labels for table display
                            medicine_type: selectedMedicine.medicine_type_text || "",
                            dose: selectedMedicine.dose_text || "",
                            frequency: selectedMedicine.frequency_text || "",
                            howToTake: selectedMedicine.how_to_take_text || "",
                            anupan: selectedMedicine.anupana_text || "",
                            package_qty: selectedMedicine.package_qty || "1",

                            item_subtotal: prices.item_subtotal,
                            item_cgst_amount: prices.item_cgst_amount,
                            item_sgst_amount: prices.item_sgst_amount,
                            item_igst_amount: prices.item_igst_amount,
                            item_gst_price: prices.item_gst_price,
                            item_igst_price: prices.item_igst_price,
                          }));
                          setSelectedMedicineUnit(selectedMedicine?.unit_text || "")
                        }}
                        placeholder="Select Medicine"
                      />

                      {errors.medicineName && (
                        <small className="text-danger">{errors.medicineName}</small>
                      )}

                      {/* External Toggle */}
                      <div className="d-flex align-items-center mt-2" style={{ gap: "6px" }}>
                        <input
                          type="checkbox"
                          checked={formData.isExternal || false}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              isExternal: e.target.checked,
                              medicine_id: null,
                              medicineName: "",
                            })
                          }
                          style={{ width: "16px", height: "16px", cursor: "pointer" }}
                        />
                        <span style={{ fontSize: "13px" }}>External Medicine?</span>
                      </div>
                    </div>

                    {/* Medicine Type */}
                    <div className="col-xl-2 col-lg-6">
                      <label className="form-label fw-semibold text-nowrap">Medicine Type</label>

                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={formData.medicine_type || ""}
                        readOnly
                        style={{
                          backgroundColor: "#f5f5f5",
                          cursor: "not-allowed",
                        }}
                      />

                      {errors.medicine_type && (
                        <small className="text-danger">{errors.medicine_type}</small>
                      )}
                    </div>

                    {/* Dose - with unit display */}
                    <div className="col-xl-2 col-lg-6">
                      <label className="form-label fw-semibold">Dose</label>

                      <OverlayTrigger
                        placement="top"
                        overlay={
                          !isMedicineSelected ? (
                            <Tooltip id="dose-tooltip">
                              Please select medicine first
                            </Tooltip>
                          ) : <></>
                        }
                      >
                        <div>
                          <Select
                            options={doseOptions.map(opt => ({
                              ...opt,
                              label: selectedMedicineUnit ? `${opt.label} ${selectedMedicineUnit}` : opt.label
                            }))}
                            value={
                              doseOptions.find(o => String(o.value) === String(formData.default_dose_id))
                                ? {
                                    ...doseOptions.find(o => String(o.value) === String(formData.default_dose_id)),
                                    label: selectedMedicineUnit
                                      ? `${doseOptions.find(o => String(o.value) === String(formData.default_dose_id)).label} ${selectedMedicineUnit}`
                                      : doseOptions.find(o => String(o.value) === String(formData.default_dose_id)).label
                                  }
                                : null
                            }
                            onChange={(selected) =>
                              setFormData({
                                ...formData,
                                default_dose_id: selected.value,
                                dose: selected.label,
                              })
                            }
                            isDisabled={!isMedicineSelected}
                          />
                        </div>
                      </OverlayTrigger>

                      {errors.dose && <small className="text-danger">{errors.dose}</small>}
                    </div>
                    {/* Frequency */}
                    <div className="col-xl-3 col-lg-6">
                      <label className="form-label fw-semibold">Frequency</label>
                      {/* <textarea
                        name="frequency"
                        value={formData.frequency}
                        onChange={handleONChange}
                        className="form-control form-control-sm"
                        placeholder="e.g. Twice a day"
                        rows="2"
                      /> */}
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          !isMedicineSelected ? (
                            <Tooltip>Please select medicine first</Tooltip>
                          ) : <></>
                        }
                      >
                        <div>
                          <Select
                            options={frequencyOptions}
                            value={
                              frequencyOptions.find(
                                (o) => String(o.value) === String(formData.default_frequency_id)
                              ) || null
                            }
                            onChange={(selected) =>
                              setFormData({
                                ...formData,
                                default_frequency_id: selected.value,
                                frequency: selected.label,
                              })
                            }
                            isDisabled={!isMedicineSelected}
                          />
                        </div>
                      </OverlayTrigger>
                      {errors.frequency && <small className="text-danger">{errors.frequency}</small>}
                    </div>

                    {/* Quantity */}
                    <div className="col-xl-2 col-lg-6">
                      <label className="form-label fw-semibold text-nowrap">Quantity</label>
                      <input
                        type="text"
                        name="quantity"
                        value={formData.quantity}
                        onChange={handleONChange}
                        className="form-control form-control-sm"
                        placeholder="e.g. 10"
                        readOnly
                      />
                      {/* <small className="text-muted">
                        Required: {formData.calculated_required_tabs || 0} tablets <br />
                        Packaging: {formData.package_qty || 0} per pack <br />
                        Giving: {formData.quantity || 0} packs ({formData.calculated_final_tabs || 0} tablets)
                      </small> */}
                      {errors.quantity && <small className="text-danger">{errors.quantity}</small>}
                    </div>

                    {/* How to Take */}
                    <div className="col-xl-3 col-lg-6">
                      <label className="form-label fw-semibold">How to Take?</label>
                      {/* <textarea
                        name="howToTake"
                        value={formData.howToTake}
                        onChange={handleONChange}
                        className="form-control form-control-sm"
                        placeholder="e.g. After meals"
                        rows="2"
                      /> */}
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          !isMedicineSelected ? (
                            <Tooltip>Please select medicine first</Tooltip>
                          ) : <></>
                        }
                      >
                        <div>
                          <Select
                            options={howToTakeOptionsWithOther}   // ✅ Correct
                            value={
                              howToTakeOptionsWithOther.find(
                                o => o.value == formData.how_to_take_id
                              ) || null
                            }
                            onChange={(selected) => {
                              if (!selected) return;

                              if (selected.value === "other") {
                                setFormData(prev => ({
                                  ...prev,
                                  howToTake: "",
                                  how_to_take_id: "other"
                                }))
                              } else {
                                setFormData(prev => ({
                                  ...prev,
                                  howToTake: selected.label,
                                  how_to_take_id: selected.value
                                }))
                              }
                            }}
                            isDisabled={!isMedicineSelected}
                          />

                          {formData.how_to_take_id === "other" && (
                            <div className="position-relative mt-2">

                              <textarea
                                className="form-control pe-5 pb-4"
                                rows="3"
                                placeholder="Enter custom How to take"
                                value={formData.howToTake}
                                onChange={(e) =>
                                  setFormData(prev => ({
                                    ...prev,
                                    howToTake: e.target.value
                                  }))
                                }
                                style={{
                                  resize: "none",
                                  paddingBottom: "35px"   // 🔥 space for buttons inside
                                }}
                              />

                              {/* 🔽 Bottom Inside Controls */}
                              <div
                                style={{
                                  position: "absolute",
                                  bottom: "6px",
                                  right: "8px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                }}
                              >
                                {/* 🌐 Language Toggle */}
                                <button
                                  type="button"
                                  onClick={toggleSpeechLang}
                                  style={{
                                    padding: "2px 6px",
                                    borderRadius: "8px",
                                    border: "1px solid #ccc",
                                    background: "#fff",
                                    fontSize: "10px",
                                    height: "22px"
                                  }}
                                >
                                  {speechLang === "en-IN" ? "EN" : "MR"}
                                </button>

                                {/* 🎙 Mic */}
                                <button
                                  type="button"
                                  onClick={() =>
                                    startListening("howToTake", (prevText) =>
                                      setFormData(prev => ({
                                        ...prev,
                                        howToTake: prevText
                                      }))
                                    )
                                  }
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                    borderRadius: "50%",
                                    border: "none",
                                    background: activeMic === "howToTake" ? "#ff4d4d" : "#f1f3f5",
                                    boxShadow:
                                      activeMic === "howToTake"
                                        ? "0 0 6px rgba(255,0,0,0.6)"
                                        : "0 2px 4px rgba(0,0,0,0.2)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <FaMicrophone
                                    size={12}
                                    color={activeMic === "howToTake" ? "white" : "#333"}
                                  />
                                </button>
                              </div>

                            </div>
                          )}

                        </div>
                      </OverlayTrigger>

                      {errors.howToTake && <small className="text-danger">{errors.howToTake}</small>}
                    </div>
                    {/* Anupan */}
                    <div className="col-xl-2 col-lg-6">
                      <label className="form-label fw-semibold">Anupan</label>

                      <OverlayTrigger
                        placement="top"
                        overlay={
                          !isMedicineSelected ? (
                            <Tooltip>Please select medicine first</Tooltip>
                          ) : <></>
                        }
                      >
                        <div>
                          <Select
                            options={anupanOptions}
                            value={
                              anupanOptions.find(
                                o => String(o.value) === String(formData.anupana_id)
                              ) || null
                            }
                            onChange={(selected) => {
                              setFormData(prev => ({
                                ...prev,
                                anupan: selected?.label || "",
                                anupana_id: selected?.value || null
                              }))
                            }}

                            isDisabled={!isMedicineSelected}
                          />
                        </div>
                      </OverlayTrigger>

                      {errors.anupan && (
                        <small className="text-danger">{errors.anupan}</small>
                      )}
                    </div>

                    {/* Default Instructions – show beside Anupan */}
                    {formData.default_instructions && (
                      <div className="col-xl-7 col-lg-12">
                        <label className="form-label fw-semibold">
                          Default Instructions
                        </label>

                        <div
                          style={{
                            padding: "8px",
                            background: "#f5f5f5",
                            borderRadius: "6px",
                            fontSize: "13px"
                          }}
                        >
                          {formData.default_instructions}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Custom Medicine + Duration */}
                  <div className="row align-items-center mt-4">

                    {(!isEditing) && (
                      <div className="col d-flex align-items-center justify-content-between">

                        {/* Left side: radios + input */}
                        <div className="d-flex align-items-center gap-4 flex-nowrap">

                          {/* Panchakarma */}
                          <div className="form-check d-flex align-items-center gap-2 m-0">
                            <input
                              className="form-check-input m-0"
                              type="radio"
                              name="treatmentType"
                              id="panchakarmaRadio"
                              value="panchakarma"
                              checked={treatmentType === "panchakarma"}
                              onChange={(e) => {
                                setTreatmentType(e.target.value);
                                setShowCustomMedicineTable(false);
                                setPanchakarmaRecommended(true);

                                setFormData(prev => ({
                                  ...prev,
                                  treatmentType: "panchakarma",
                                  prescriptionDuration: "" // reset
                                }));
                              }}
                            />
                            <label className="form-check-label fw-semibold mb-0 text-nowrap" htmlFor="panchakarmaRadio">
                              Panchakarma
                            </label>
                          </div>

                          {/* Custom Medicine */}
                          <div className="form-check d-flex align-items-center gap-2 m-0">
                            <input
                              className="form-check-input m-0"
                              type="radio"
                              name="treatmentType"
                              id="customMedicineRadio"
                              value="customMedicine"
                              checked={treatmentType === "customMedicine"}
                              onChange={() => {
                                setTreatmentType("customMedicine");
                                setPanchakarmaRecommended(false);
                                setShowCustomMedicineTable(true);

                                // ✅ ADD THIS
                                setFormData(prev => ({
                                  ...prev,
                                  treatmentType: "customMedicine"
                                }));
                              }}
                            />
                            <label className="form-check-label fw-semibold mb-0 text-nowrap" htmlFor="customMedicineRadio">
                              Custom Medicine
                            </label>
                          </div>

                          {/* Days input */}
                          {(showCustomMedicineTable || isEditingCustom) && (
                            <input
                              type="number"
                              className="form-control form-control-sm"
                              name="prescriptionDuration"
                              value={formData.prescriptionDuration}
                              onChange={handleONChange}
                              min="1"
                              placeholder="Duration in days"
                              style={{ width: "160px" }}
                            />
                          )}

                        </div>

                        {/* Right side: buttons */}
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-success btn-sm"
                            onClick={
                              (showCustomMedicineTable || isEditingCustom) && !isEditing
                                ? handleCustomSave
                                : handleSave
                            }
                           
                          >
                            {isEditing || isEditingCustom ? "Update" : "Save"}
                          </button>

                          <button
                            className="btn btn-outline-secondary btn-sm"
                            onClick={handleDiscard}
                          >
                            Discard
                          </button>
                        </div>

                      </div>
                    )}

                  </div>

                </div>
              </div>
            )}
            {/* Custom Medicine Table with Duration Column */}
            {customizedPrescriptions.length === 0 ? (
              <div className="text-center py-4"></div>
            ) : (
              <div
                style={{
                  marginTop: "24px",
                  border: "2px solid #ddd",
                  borderRadius: "5px",
                  marginBottom: "0.1rem", 
                }}
                className="table-responsive"
              >
                <h5 className=" p-2 border-bottom mb-0">Custom Medicines</h5>
                <table
                  className="table header-border"
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                  }}
                >
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      backgroundColor: "#f8f9fa",
                      //zIndex: 10,
                      borderBottom: "2px solid #ddd",
                    }}
                  >
                    <tr className="table-info">
                      <th
                        style={{
                          padding: "10px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        Medicine Name
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        Medicine Type
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        Dose
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        Frequency
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        Quantity
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        How To Take
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        Duration{" "}
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        Anupan{" "}
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {customizedPrescriptions.map((item, index) => (
                      <tr key={index}>
                        {editCustomIndex === index ? (
                          <td colSpan="10" style={{ padding: "20px" }}>
                            <div
                              style={{
                                background: "white",
                                border: "1px solid #ddd",
                                borderRadius: "10px",
                                padding: "20px",
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "20px",
                              }}
                            >

                              {/* Medicine Name */}
                              <div>
                                <label className="form-label fw-semibold">Medicine Name</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={formData.medicineName?.label || ""}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      medicineName: {
                                        ...formData.medicineName,
                                        label: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </div>

                              {/* Medicine Type */}
                              <div>
                                <label className="form-label fw-bold">Medicine Type</label>
                                <input
                                  type="text"
                                  className="form-control form-control-sm"
                                  value={formData.medicine_type || ""}
                                  onChange={(e) =>
                                    setFormData({ ...formData, medicine_type: e.target.value })
                                  }
                                  readOnly
                                  style={{
                                    backgroundColor: "#f5f5f5",
                                    cursor: "not-allowed",
                                  }}
                                />
                              </div>

                              {/* Dose - with unit display */}
                              <div>
                                <label className="form-label fw-bold">Dose</label>
                                <Select
                                  options={doseOptions.map(opt => ({
                                    ...opt,
                                    label: selectedMedicineUnit ? `${opt.label} ${selectedMedicineUnit}` : opt.label
                                  }))}
                                  value={
                                    doseOptions.find(o => String(o.value) === String(formData.default_dose_id))
                                      ? {
                                          ...doseOptions.find(o => String(o.value) === String(formData.default_dose_id)),
                                          label: selectedMedicineUnit
                                            ? `${doseOptions.find(o => String(o.value) === String(formData.default_dose_id)).label} ${selectedMedicineUnit}`
                                            : doseOptions.find(o => String(o.value) === String(formData.default_dose_id)).label
                                        }
                                      : null
                                  }
                                  onChange={(selected) =>
                                    setFormData({
                                      ...formData,
                                      default_dose_id: selected.value,
                                      dose: selected.label,
                                    })
                                  }
                                />
                              </div>

                              {/* Frequency */}
                              <div>
                                <label className="form-label fw-bold">Frequency</label>
                                <Select
                                  options={frequencyOptions}
                                  value={
                                    frequencyOptions.find(
                                      o => String(o.value) === String(formData.default_frequency_id)
                                    ) || null
                                  }
                                  onChange={(selected) =>
                                    setFormData({
                                      ...formData,
                                      default_frequency_id: selected.value,
                                      frequency: selected.label,
                                    })
                                  }
                                />
                              </div>

                              {/* Quantity */}
                              <div>
                                <label className="form-label fw-bold">Quantity</label>
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  value={formData.quantity}
                                  onChange={(e) =>
                                    setFormData({ ...formData, quantity: e.target.value })
                                  }
                                  readOnly
                                />
                              </div>

                              {/* How to Take */}
                              <div style={{ gridColumn: "span 2" }}>
                                <label className="form-label fw-bold">How to Take</label>
                                <Select
                                  options={howToTakeOptionsWithOther}
                                  value={
                                    howToTakeOptionsWithOther.find(
                                      o => o.value == formData.how_to_take_id
                                    ) || null
                                  }
                                  onChange={(selected) => {
                                    if (!selected) return;

                                    if (selected.value === "other") {
                                      setFormData(prev => ({
                                        ...prev,
                                        howToTake: "",
                                        how_to_take_id: "other"
                                      }))
                                    } else {
                                      setFormData(prev => ({
                                        ...prev,
                                        howToTake: selected.label,
                                        how_to_take_id: selected.value
                                      }))
                                    }
                                  }}
                                />

                                {formData.how_to_take_id === "other" && (
                                  <div className="position-relative mt-2">

                                    <textarea
                                      className="form-control pe-5 pb-4"
                                      rows="3"
                                      placeholder="Enter custom instructions"
                                      value={formData.howToTake}
                                      onClick={() =>
                                        startListening("howToTake", (text) => {
                                          setFormData(prev => ({
                                            ...prev,
                                            howToTake: prev.howToTake
                                              ? prev.howToTake + " " + text
                                              : text
                                          }))
                                        })
                                      }
                                      style={{
                                        resize: "none",
                                        paddingBottom: "35px"   // 🔥 space for buttons inside
                                      }}
                                    />

                                    {/* 🔽 Bottom Inside Controls */}
                                    <div
                                      style={{
                                        position: "absolute",
                                        bottom: "6px",
                                        right: "8px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                    >
                                      {/* 🌐 Language Toggle */}
                                      <button
                                        type="button"
                                        onClick={toggleSpeechLang}
                                        style={{
                                          padding: "2px 6px",
                                          borderRadius: "8px",
                                          border: "1px solid #ccc",
                                          background: "#fff",
                                          fontSize: "10px",
                                          height: "22px"
                                        }}
                                      >
                                        {speechLang === "en-IN" ? "EN" : "MR"}
                                      </button>

                                      {/* 🎙 Mic */}
                                      <button
                                        type="button"
                                        onClick={() =>
                                          startListening("howToTake", (prevText) =>
                                            setFormData(prev => ({
                                              ...prev,
                                              howToTake: prevText
                                            }))
                                          )
                                        }
                                        style={{
                                          width: "24px",
                                          height: "24px",
                                          borderRadius: "50%",
                                          border: "none",
                                          background: activeMic === "howToTake" ? "#ff4d4d" : "#f1f3f5",
                                          boxShadow:
                                            activeMic === "howToTake"
                                              ? "0 0 6px rgba(255,0,0,0.6)"
                                              : "0 2px 4px rgba(0,0,0,0.2)",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <FaMicrophone
                                          size={12}
                                          color={activeMic === "howToTake" ? "white" : "#333"}
                                        />
                                      </button>
                                    </div>

                                  </div>
                                )}
                              </div>

                              {/* Anupan */}
                              <div>
                                <label className="form-label fw-bold">Anupan</label>
                                <Select
                                  options={anupanOptions}  // ✅ FIX
                                  value={anupanOptions.find(
                                    o => String(o.value) === String(formData.anupana_id)
                                  ) || null}
                                  onChange={(selected) => {
                                    setFormData(prev => ({
                                      ...prev,
                                      anupan: selected?.label || "",
                                      anupana_id: selected?.value || null
                                    }))
                                  }}
                                />
                              </div>

                              {/* Duration */}
                              <div style={{ gridColumn: "span 2", display: "flex", gap: "20px", alignItems: "center" }}>

                                {/* Custom checkbox */}
                                <div className="form-check d-flex align-items-center" style={{ gap: "8px" }}>
                                  <input
                                    type="checkbox"
                                    checked={true}
                                    disabled
                                    style={{ width: "18px", height: "18px" }}
                                  />
                                  <label className="fw-semibold mb-0">Custom Medicine</label>
                                </div>

                                {/* Duration */}
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  style={{ width: "120px" }}
                                  value={formData.prescriptionDuration}
                                  onChange={(e) =>
                                    setFormData({
                                      ...formData,
                                      prescriptionDuration: e.target.value,
                                    })
                                  }
                                />

                              </div>

                              {/* Buttons */}
                              <div style={{
                                gridColumn: "span 2",
                                display: "flex",
                                justifyContent: "end",
                                alignItems: "center",
                                gap: "10px"
                              }}>
                                <button
                                  className="btn btn-success"
                                  onClick={handleCustomSave}
                                  disabled={!formData.prescriptionDuration && !duration}
                                >
                                  Save
                                </button>

                                <button
                                  className="btn btn-outline-secondary"
                                  onClick={() => setEditCustomIndex(null)}
                                >
                                  Cancel
                                </button>
                              </div>

                            </div>
                          </td>
                        ) : (
                          <>
                            <td style={{ padding: "10px" }}>{item.name}</td>
                            <td style={{ padding: "10px" }}>{item.medicine_type}</td>
                            <td style={{ padding: "10px" }}>{item.dose}</td>
                            <td style={{ padding: "10px" }}>{item.frequency}</td>
                            <td style={{ padding: "10px" }}>{item.quantity}</td>
                            <td style={{ padding: "10px" }}>{item.howToTake}</td>
                            <td style={{ padding: "10px" }}>{item.duration}</td>
                            <td style={{ padding: "10px" }}>{item.anupan}</td>

                            <td style={{ padding: "10px" }}>
                              <div className="d-flex justify-content-around">
                                <DoctorOnly tooltip="Only doctors can edit prescriptions">
                                  <Link
                                    to="#"
                                    className="view detail me-4"
                                    onClick={() => handleCustomEdit(index)}
                                  >
                                    <i className="fa fa-pencil-alt text-success"></i>
                                  </Link>
                                </DoctorOnly>

                                <DoctorOnly tooltip="Only doctors can delete prescriptions">
                                  <Link to="#" onClick={() => handleCustomDelete(index)}>
                                    <i className="fa fa-trash text-danger"></i>
                                  </Link>
                                </DoctorOnly>
                              </div>
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
        {(modifiedPrescriptions.length > 0 || customizedPrescriptions.length > 0) && (
          <div className="col-xl-12" style={{ 
            marginTop: customizedPrescriptions.length > 0 ? "0" : "-8rem" 
          }}>
            <div className="card shadow-none">
              <div className="card-body" style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                {/* <div className="col-md-3 mb-3 d-flex align-items-end" style={{ paddingTop: "4px" }}> */}
                <div className="col-md-6 mb-2">
                  <div className="d-flex align-items-center gap-3">

                    {/* Checkbox */}
                    <div className="form-check d-flex align-items-center mb-0">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        // checked={formData.isRegularServiceCall}
                        checked={formData.isRegularServiceCall ?? true}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            isRegularServiceCall: e.target.checked,
                          }))
                        }
                        style={{ width: "18px", height: "18px", cursor: "pointer" }}
                      />
                      <label className="form-check-label ms-2 mb-0">
                        Regular Service Call
                      </label>
                    </div>

                    {/* Small Frequency Input */}
                    {formData.isRegularServiceCall === false && (
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Frequency (days)"
                        value={formData.frequencyDays || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            frequencyDays: e.target.value,
                          }))
                        }
                        min="1"
                        style={{ width: "180px", height: "36px" }}
                      />
                    )}

                  </div>
                </div>
                <div className="mb-1 position-relative">
                  <label className="form-label mb-1 me-2">Notes:</label>

                  <textarea
                    className="form-control pe-5"
                    rows="3"
                    placeholder="Add any notes here..."
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    readOnly={currentUser?.role_name !== "Doctor"}
                  />

                  {currentUser?.role_name === "Doctor" && (
                    <>
                      {/* 🌐 Language Toggle */}
                      <button
                        type="button"
                        onClick={toggleSpeechLang}
                        style={{
                          position: "absolute",
                          right: "44px",
                          top: "75px",
                          padding: "2px 8px",
                          borderRadius: "10px",
                          border: "1px solid #ccc",
                          background: "#fff",
                          fontSize: "11px",
                        }}
                      >
                        {speechLang === "en-IN" ? "EN" : "MR"}
                      </button>

                      {/* 🎙 Mic */}
                      <button
                        type="button"
                        onClick={() => startListening("notes", setNote)}
                        style={{
                          position: "absolute",
                          right: "8px",
                          top: "70px",
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          border: "none",
                          background: activeMic === "notes" ? "#ff4d4d" : "#f1f3f5",
                          boxShadow:
                            activeMic === "notes"
                              ? "0 0 8px rgba(255,0,0,0.6)"
                              : "0 2px 4px rgba(0,0,0,0.2)",
                        }}
                      >
                        <FaMicrophone
                          size={14}
                          color={activeMic === "notes" ? "white" : "#333"}
                        />
                      </button>
                    </>
                  )}

                  {currentUser?.role_name !== "Doctor" && (
                    <small className="text-muted">Only doctors can add notes</small>
                  )}
                </div>


                {/* <div className="mb-3 mt-2 position-relative">
                  <label className="form-label mb-1 me-2">Pathyas:</label>

                  <textarea
                    className="form-control pe-5"
                    rows="3"
                    placeholder="Enter Pathyas..."
                    value={pathyas}
                    onChange={(e) => setPathyas(e.target.value)}
                    readOnly={currentUser?.role_name !== "Doctor"}
                  />

                  {currentUser?.role_name === "Doctor" && (
                    <>
                      <button
                        type="button"
                        onClick={toggleSpeechLang}
                        style={{
                          position: "absolute",
                          right: "44px",
                          top: "75px",
                          padding: "2px 8px",
                          borderRadius: "10px",
                          border: "1px solid #ccc",
                          background: "#fff",
                          fontSize: "11px",
                        }}
                      >
                        {speechLang === "en-IN" ? "EN" : "MR"}
                      </button>

                      <button
                        type="button"
                        onClick={() => startListening("pathyas", setPathyas)}
                        style={{
                          position: "absolute",
                          right: "8px",
                          top: "70px",
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          border: "none",
                          background: activeMic === "pathyas" ? "#ff4d4d" : "#f1f3f5",
                          boxShadow:
                            activeMic === "pathyas"
                              ? "0 0 8px rgba(255,0,0,0.6)"
                              : "0 2px 4px rgba(0,0,0,0.2)",
                        }}
                      >
                        <FaMicrophone
                          size={14}
                          color={activeMic === "pathyas" ? "white" : "#333"}
                        />
                      </button>
                    </>
                  )}

                  {currentUser?.role_name !== "Doctor" && (
                    <small className="text-muted">Only doctors can add pathyas</small>
                  )}
                </div> */}
                {/* 🆕 Multi‑select Pathyas */}
                <div className="mb-3 mt-2">
                <label className="form-label mb-1 me-2">
  Pathyas:<span style={{ color: "red" }}>*</span>
</label>
                  <DoctorOnly tooltip="Only doctors can edit pathyas">
                    <Select
                      isMulti={true}
                      options={pathyaOptions}
                      value={pathyas}
                     
                      // onChange={(selected) => {
                      //   setPathyas(selected);
                      //   setErrors((prev) => ({
                      //     ...prev,
                      //     pathyas: ""
                      //   }));
                      // }}
                      onChange={(selected) => {
                        setPathyas(selected);
                    
                        // ✅ remove error when user selects
                        setErrors((prev) => ({
                          ...prev,
                          pathyas: "",
                        }));
                      }}
                      isDisabled={currentUser?.role_name !== "Doctor"}
                      placeholder="Select Pathya(s)"
                    />
                  </DoctorOnly>
                  {errors.pathyas && (
  <div style={{ color: "red", fontSize: "13px", marginTop: "4px" }}>
    {errors.pathyas}
  </div>
)}
                </div>

                {/* Panchakarma Recommended */}
                <div
                  className="form-check mt-2 d-flex align-items-center"
                  style={{ gap: "8px", paddingLeft: "0" }}
                >
                  <DoctorOnly tooltip="Only doctors can recommend Panchakarma">
                    <input
                      className="form-check-input m-0"
                      type="checkbox"
                      id="panchakarmaRecommended"
                      checked={panchakarmaRecommended}
                      onChange={(e) => setPanchakarmaRecommended(e.target.checked)}
                      disabled={currentUser?.role_name !== "Doctor"} // force disable for non-doctors
                      style={{ width: "18px", height: "18px", cursor: "pointer" }}
                    />
                    <label
                      className="form-check-label mb-0"
                      htmlFor="panchakarmaRecommended"
                      style={{ cursor: "pointer" }}
                    >
                      Panchakarma Recommended
                    </label>
                  </DoctorOnly>
                </div>

                {/* Show Online/Offline options when Panchakarma is selected */}
                {/* {panchakarmaRecommended && (
                  <div style={{ marginLeft: "2rem", marginBottom: "10px" }}>
                    <label className="form-label fw-semibold">Mode</label>
                    <div className="d-flex gap-3">
                      <div className="form-check">
                      
                        <label className="form-check-label" htmlFor="modeOffline">
                          Offline
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="karmaMode"
                          id="modeOnline"
                          value="online"
                          checked={karmaMode === "online"}
                          onChange={(e) => setKarmaMode(e.target.value)}
                        />
                        <label className="form-check-label" htmlFor="modeOnline">
                          Online
                        </label>
                      </div>

                    </div>
                  </div>
                )} */}
                <div className="row">
                  {/* ================= LEFT : KARMA ================= */}
                  {/* <div className="col-md-6">
                    <h6 className="fw-bold mb-2 text-center">Karma</h6>

                    {mainOptions.map((option, index) => (
                      <div
                        key={option.key}
                        className="p-2 border rounded mb-2 d-flex align-items-center"
                        style={{ background: "#f8f9fa" }}
                        draggable
                        onDragStart={(e) => handleDragStart(e, index)}
                        onDragOver={allowDrop}
                        onDrop={(e) => handleDrop(e, index)}
                      >
                        <span
                          style={{
                            cursor: "grab",
                            marginRight: "8px",
                            fontSize: "18px",
                            color: "#888",
                          }}
                        >
                          ≡
                        </span>

                        <input
                          className="form-check-input me-2"
                          type="checkbox"
                          id={option.key}
                          checked={option.checked}
                          onChange={(e) => {
                            if (option.key === "virechan") setVirechanChecked(e.target.checked)
                            else if (option.key === "vaman") setVimanChecked(e.target.checked)
                            else if (option.key === "basti") setBastiChecked(e.target.checked)
                          }}
                        />

                        <label className="form-check-label fw-bold" htmlFor={option.key}>
                          {option.label}
                        </label>
                      </div>
                    ))}
                  </div> */}

                  {/* ================= RIGHT : UPKARMA ================= */}
                  {/* <div className="col-md-6">
                    <h6 className="fw-bold mb-2 text-center">Upkarma</h6>

                    {mainOptions.map((option, index) =>
                      Object.keys(option.subs).map((sub) => (
                        <div
                          key={`${option.key}-${sub}`}
                          className="p-2 border rounded mb-2 d-flex align-items-center"
                          style={{ background: "#f8f9fa" }}
                          draggable
                          onDragStart={(e) => handleSubDragStart(e, index, sub)}
                          onDragOver={allowDrop}
                          onDrop={(e) => handleSubDrop(e, index, sub)}
                        >
                          <span
                            style={{
                              cursor: "grab",
                              marginRight: "8px",
                              fontSize: "18px",
                              color: "#888",
                            }}
                          >
                            ≡
                          </span>

                          <input
                            className="form-check-input me-2"
                            type="checkbox"
                            id={`${option.key}-${sub}`}
                            checked={option.subs[sub]}
                            onChange={(e) => {
                              const updated = [...mainOptions]
                              updated[index].subs[sub] = e.target.checked
                              setMainOptions(updated)
                            }}
                          />

                          <label className="form-check-label">
                            {sub.charAt(0).toUpperCase() + sub.slice(1)} {option.label}
                          </label>
                        </div>
                      ))
                    )}
                  </div> */}
                </div>



                <div style={{ marginTop: "1rem" }}>
                  <label className="form-label fw-semibold mb-2">Discount</label>

                  {/* Radio Buttons */}
                  <div className="d-flex align-items-center gap-4 mb-2">

                    {/* 🆕 N/A (No Discount) - added before Percentage */}
                    <div className="form-check d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="discountType"
                        value="none"
                        checked={discountType === "" || discountType === "none"}
                        onChange={() => {
                          setDiscountType("");
                          setDiscountPercentage("");
                          setDiscountAmount("");
                        }}
                      />
                      <label className="form-check-label mb-0">N/A (No Discount)</label>
                    </div>

                    {/* Percentage Option */}
                    <div className="form-check d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="discountType"
                        value="percentage"
                        checked={discountType === "percentage"}
                        onChange={() => {
                          setDiscountType("percentage");
                          setDiscountAmount("");   // reset other
                        }}
                      />
                      <label className="form-check-label mb-0">
                        Percentage (%)
                      </label>
                    </div>

                    {/* Amount Option */}
                    <div className="form-check d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="discountType"
                        value="amount"
                        checked={discountType === "amount"}
                        onChange={() => {
                          setDiscountType("amount");
                          setDiscountPercentage(""); // reset other
                        }}
                      />
                      <label className="form-check-label mb-0">
                        Amount (₹)
                      </label>
                    </div>

                  </div>

                  {/* Conditional Input Field */}
                  {discountType === "percentage" && (
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Discount %"
                      value={discountPercentage}
                      onChange={(e) => setDiscountPercentage(e.target.value)}
                      style={{ width: "200px", height: "35px", fontSize: "14px" }}
                    />
                  )}

                  {discountType === "amount" && (
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Discount Amount"
                      value={discountAmount}
                      onChange={(e) => setDiscountAmount(e.target.value)}
                      style={{ width: "200px", height: "35px", fontSize: "14px" }}
                    />
                  )}
                </div>
                <div
                  style={{
                    marginTop: "1.5rem",   // increased top space
                    fontSize: "13px",
                    color: "#6c757d",
                    fontStyle: "italic",
                    borderLeft: "3px solid #b0b0b0",
                    paddingLeft: "8px"
                  }}
                >
                  *Disclaimer: This is a system-generated Ayurvedic prescription summary.
                  Final recommendations may vary based on patient condition.*
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="text-end" style={{ marginTop: "0.5rem" }}>
                    <DoctorOnly tooltip="Only doctors can generate prescriptions">
                      <Button
                        variant="primary"
                        onClick={handleGeneratePrescription}
                        disabled={
                          currentUser?.role_name !== "Doctor" ||
                          isSubmitting ||
                          modifiedPrescriptions.length === 0
                        }
                      >
                        {isSubmitting
                          ? editingPrescriptionId
                            ? "Updating..."
                            : "Creating..."
                          : editingPrescriptionId
                            ? "Update Prescription"
                            : "Generate Prescription"}
                      </Button>
                    </DoctorOnly>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div >
    </>
  )
}

export default PatientPrescription;